import React, { Component } from "react";
import "./Documents.css";
import { Auth } from "aws-amplify";
import magnifying_glass from "../../assets/images/magnifying-glass.svg";
import attach_gray from "../../assets/images/attach_gray.png";
import message from "../../assets/images/message.png";
import ic_clear_24px from "../../assets/images/ic_clear_24px@2x.png";
import file_gray from "../../assets/images/file_gray.png";
import tic_black from "../../assets/images/tic_black.png";
import decline_pop_close from "../../assets/images/decline_pop_close.png";
import down_arrow_amprvoe from "../../assets/images/down_arrow_amprvoe.png";
import plus_icon from "../../assets/images/plus_icon.png";
import upload_icon from "../../assets/images/upload_icon.png";
import envelop_icon from "../../assets/images/envelop_icon.png";
import more_dots from "../../assets/images/more-dots.png";
import tick_gray from "../../assets/images/tick_gray.png";
import { Link } from "react-router-dom";
import { Storage } from "aws-amplify";
import Dropzone from "react-dropzone";
import Preloader from "../../assets/images/Preloader.gif";
import Header from "../Common/Header/Header";
import $ from "jquery";
import moment from "moment";
import "moment-timezone";
import { API } from "aws-amplify";
import { toast } from "react-toastify";
//import ip from 'ip';
import axios from "axios";
import loading_pdf_preview from "../../assets/images/Preloader.gif";
import { getUniqueListBy } from "../../utils/helpers";

var Modal = require("react-bootstrap-modal");
require("react-bootstrap-modal/lib/css/rbm-patch.css");
window.jQuery = $;
window.$ = $;
global.jQuery = $;

var PDFDocument = "";

class Documents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      comment_add: "",
      comment_counter: 0,
      doc_count: 0,
      doc_list: [],
      doc_external_list: [],
      doc_Guid: "",
      currentTabDigitalFormData: [],
      moreDetailsModalOpen: false,
      declineModalOpen: false,
      sendLinkToUserInEmail: false,
      selectProjectedUserError: "",
      formpackReceiverEmail: "",
      formpackReceiverRname: "",
      formpackReceiverRphone: "",
      selectProjectedUserError: "",
      formpackReceiverEmail: "",
      formpackReceiverGuid: "",
      formpackReceiverRname: "",
      formpackReceiverRphone: "",
      projectedUsers: "",
      projectedUsersHTMLState: "",
      formpackReceiverGuid: "",
      formpacksendableGuid: "",
      handleSendLinkToUserShow: false,
      isLoading: false,
      digitalForms: [],
      digitalFormsSearch: [],

      digitalForm: {},
      digitalFormGuids: [],
      documents: [],
      digitalFormCompleteData: [],
      digitalFormCompleteDataSearch: [],

      sortBy: "",
      search: "",
      isDigitalFormExist: false,

      checkbox3_tbl: false,
      Approve: 0,
      Approved: 0,
      Declined: 0,
      Draft: 0,
      Pending: 0,
      otherApprove: 0,
      CurrentTab: "Draft",
      CurrentForm: false,
      DeclineText: "",

      draftForms: [],
      draftFormsCompleteDataSearch: [],
      pendingForms: [],
      pendingFormsCompleteDataSearch: [],
      approverForms: [],
      approverFormsCompleteDataSearch: [],
      declinedForms: [],
      declinedFormsCompleteDataSearch: [],
      approvedForms: [],
      approvedFormsCompleteDataSearch: [],
      allForms: [],
      allFormsCompleteDataSearch: [],
      excelImportData: "",
      formTemaplteResponse: "",
      selectedDocumentForReadAllActivities: "",
      showPreviewLoader: false,
      selectedDocDetails: [],
      documentsDescriptionLoading: false,
      selectedAttachments: [],
      documentUrl: "",
      EmailTemplates: [],
      placeHolderArray: [],
      SignatureKey: false,
      TempFilePath: null,
      Signatures: {},
      selectedDFDocs: [],
      ipv4: null,
    };
  }

  // -- -- Component Did Mount -- -- //
  // -- -- -- -- -- - -- -- -- -- -- //

  componentDidMount = async () => {
    $(".modal").css("display", "none");
    this.allDigitalForm();

    var that = this;
    $(document).attr("title", "Documents");

    $(".slide-toggle").click(function () {
      var isVisible = $(".sidebar_main").toggle().is(":visible");
      //console.log(isVisible);
      if (isVisible) {
        $(this).find(".fa-caret-left").css("transform", "rotate(0deg)");
        $(".sidebar_main_right").removeClass("digital_form_approve");
      } else {
        $(this).find(".fa-caret-left").css("transform", "rotate(180deg)");
        $(".sidebar_main_right").addClass("digital_form_approve");
      }
    });
    $(".text_change").click(function () {
      var link = $(this);
      $("#show_activity").slideToggle("", function () {
        if ($(this).is(":visible")) {
          link.text("Hide Activity");
        } else {
          link.text("Show Activity");
        }
      });
    });

    if (typeof this.props.location.state !== "undefined") {
      if (this.props.location.state.successMessage === true) {
        this.props.history.push({
          state: { successMessage: false },
        });
        toast.success("Success! Record has been added successfully.", {
          autoClose: 5000,
        });
      }
    }

    this.allDigitalFormAPI()
      .then((response) => {
        if (!response.status) {
          return false;
        }
        var formDataGuid =
          response.result.length > 0 ? response.result[0].Guid : false;
        this.setState(
          {
            digitalForms: response.result,
            digitalFormsSearch: response.result,
          },
          () => {
            if (formDataGuid) {
              this.setPDFPreviews(formDataGuid);
            }
          }
        );
      })
      .catch((err) => {
        console.log("Error in getting Forms: ", err);
      });

    if (localStorage.getItem("userType") === "Approver") {
      $("#default_document_Approve").show();
      $("#default_document_draft").hide();
      this.setState({ CurrentTab: "Approve" });
      this.setCurrentForm("Approve");
    }

    try {
      var response = await this.props.postRequest(
        "/email-templates/get-email-templates",
        { Type: "All", CompanyGuid: localStorage.getItem("companyGuid") }
      );
      if (response.status) {
        this.setState({ EmailTemplates: response.result });
      }
    } catch (err) {
      console.log("/email-templates/get-email-templates error=>", err);
    }

    /*        let filename = localStorage.getItem('userEmail')+"_SignatureFile.jpg";

            Storage.vault.get(filename, {level: 'private'})
                .then(result => {
                  //console.log('Signature get=>', result);
                  var tmp = result.split('?');
                  if(typeof tmp[0] !== 'undefined'){
                    var tmp2 = tmp[0].split('private');
                    if(typeof tmp2[1] !== 'undefined'){
                      this.setState({ SignatureKey: 'private'+tmp2[1]});
                    }
                  }

            }).catch(err => console.log(err));*/

    try {
      var config_response = await this.props.postRequest("/config/get-config", {
        Type: "TempFilePath",
      });
      if (config_response.status) {
        this.setState({ TempFilePath: config_response.result[0].TempFilePath });
      }
      // console.log("/config/get-config =>", config_response);
    } catch (err) {
      console.log("/config/get-config error=>", err);
    }

    $.getJSON("https://jsonip.com?callback=?", async (jsonip) => {
      this.setState({ ipv4: jsonip.ip });
    });
  };

  handleChangeText(event) {
    let fieldName = event.target.name;
    let fleldVal = event.target.value;
    this.setState({ [fieldName]: fleldVal });
  }

  recordOnlineFormData(
    RGuid,
    RName,
    REmail,
    Rphone,
    formpackID,
    SendableUrl,
    SName
  ) {
    return this.props.postRequest("/online-forms/create", {
      RGuid: RGuid,
      RName: RName,
      REmail: REmail,
      Rphone: Rphone,
      formpackID: formpackID,
      SendableUrl: SendableUrl,
      SName: SName,
    });
  }

  LinkOfProjectedUser(RGuid, RName, REmail, formpackID, ccEmail, ExText) {
    var ExternelUri =
      "&SenderName=" +
      encodeURIComponent(localStorage.getItem("userName")) +
      "&ReceiverName=" +
      encodeURIComponent(RName);
    var ExternelLink =
      window.config.OF_SITE_URL +
      "?536dac2bc9ba290eeb81d87ee43b3faf=" +
      RGuid +
      ExternelUri;
    //console.log("ExternelLink=>", ExternelLink);
    return ExternelLink;
  }

  async submitEmail(to, msg, subject, cc, ExText) {
    var sendTo = to + (cc ? ", " + cc : "");

    return API.post("send-mail", "/allusers/send-mail", {
      body: {
        TO: sendTo,
        CC: cc,
        MSG: msg,
        SUBJECT: subject,
        ExText: ExText,
      },
    });
  }

  async sendEmail(to, msg, subject, cc, ExText, userName) {
    var sendTo = to + (cc ? ", " + cc : "");
    msg =
      "<p><strong>Hello " +
      userName +
      "</strong>,&nbsp;<br />" +
      "We are pleased to inform you that now you can save your forms once and use it whenever you want " +
      'Please <a href="' +
      msg +
      '">Click here</a>' +
      " to save your information.</p>" +
      "<p>&nbsp;</p>";
    return API.post("send-mail", "/allusers/send-mail", {
      body: {
        TO: sendTo,
        CC: cc,
        MSG: msg,
        SUBJECT: subject,
        ExText: ExText,
      },
    });
  }

  async sendEmailOnDecline(formRecord) {
    // TODO: consider the approval chain and send emails appropriately
    const approverDeclinedTemplate =
      this.getDefaultEmailContent("Declined Approver");
    if (!approverDeclinedTemplate) {
      toast.error(
        "No default Declined email template is defined for Approvers."
      );
      return;
    }

    const externalDeclinedTemplate = this.getDefaultEmailContent(
      "Declined External User"
    );
    if (!externalDeclinedTemplate) {
      toast.error(
        "No default Declined email template is defined for External Users."
      );
      return;
    }

    const signedExternalSigners = formRecord.ApprovalChain.filter(
      (a) => a.userGuid === "external-signer"
    )
      .map((a, i) => ({ ...a, Email: formRecord.ExtSigners[i]?.Email ?? "" }))
      .filter((a) => a.Signed);

    const signedApprovers = formRecord.ApprovalChain.filter(
      (a) => a.Signed && a.userGuid !== "external-signer"
    );

    const externalPartyMessage = await this.replaceExternalPartyPlaceHolder(
      externalDeclinedTemplate.BodyText
    );

    const { to: ownerEmail, message: approverMessage } =
      await this.replacePlaceHodler(
        approverDeclinedTemplate.BodyText,
        formRecord.EmpGuid
      );

    // send emails to signed external signers
    await Promise.all(
      signedExternalSigners?.map(
        async (signer) =>
          await this.props.postRequest("/users/send-mail", {
            TO: signer.Email,
            CC: "",
            MSG: externalPartyMessage,
            SUBJECT: approverDeclinedTemplate.Subject,
          })
      )
    );

    // send emails to signed approvers
    await Promise.all(
      signedApprovers?.map(async (approver) => {
        const user = await this.props.postRequest("/users/getsingleuserguid", {
          Guid: approver.userGuid,
        });
        await this.props.postRequest("/users/send-mail", {
          TO: user.EmailAddress,
          CC: "",
          MSG: approverMessage,
          SUBJECT: approverDeclinedTemplate.Subject,
        });
      })
    );

    // send email to owner of the document
    await this.props.postRequest("/users/send-mail", {
      TO: ownerEmail,
      CC: "",
      MSG: approverMessage,
      SUBJECT: approverDeclinedTemplate.Subject,
    });
  }

  sendEmailToSigner = async (to, subject, msg, attachments = undefined) => {
    var sendTo = to;
    return this.props.postRequest("/users/send-mail", {
      TO: sendTo,
      CC: "",
      MSG: msg,
      SUBJECT: subject,
      attachments,
    });
  };

  async SendLinkToProjectedUser() {
    var RGuid = this.state.formpackReceiverGuid;
    var REmail = this.state.formpackReceiverEmail;
    var RName = this.state.formpackReceiverRname;
    var Rphone = this.state.formpackReceiverRphone;
    var formpackID = this.state.formpacksendableGuid;
    var ccEmail = this.state.CarbonCopyEmail;
    var ExText = this.state.EmailExtraText;

    if (this.state.formpacksendableGuid === "") {
      this.setState({
        selectProjectedUserError: "No Form Pack Selected.",
      });
      return false;
    }
    if (
      this.state.formpackReceiverEmail === "" ||
      this.state.formpackReceiverGuid === ""
    ) {
      this.setState({
        selectProjectedUserError: "Please Select User.",
      });
      return false;
    }
    this.setState({
      handleSendLinkToUserShow: false,
    });
    var thisObj = this;
    this.setState({
      isLoading: true,
    });

    await this.recordOnlineFormData(RGuid, RName, REmail, Rphone, formpackID)
      .then((data) => {
        if (data.status === true) {
          this.setState({
            sendLinkToUserInEmail: true,
            sendLinkGuid: data.guid,
          });
        } else {
          console.log("eee 1");

          toast.error("Error in Recording Link, please try again later", {
            autoClose: 5000,
          });
        }
      })
      .catch((err) => {
        console.log("eee 2", err);
        toast.error("Error in Recording Link, please try again later", {
          autoClose: 5000,
        });
      });

    if (this.state.sendLinkToUserInEmail === true) {
      var SendableUrl = this.LinkOfProjectedUser(
        this.state.sendLinkGuid,
        REmail,
        formpackID,
        ccEmail,
        ExText
      );
      await this.sendEmail(
        REmail,
        SendableUrl,
        "Digitalforms Link Generation Practise",
        ccEmail,
        ExText,
        RName
      )
        .then((data) => {
          if (data.status === true) {
            toast.success("Email has been sent successfully", {
              autoClose: 5000,
            });
            thisObj.handleSendLinkToUserClose();
            thisObj.updateDate(formpackID);
          } else {
            toast.error("Error in sending email, please try again later", {
              autoClose: 5000,
            });
            thisObj.handleSendLinkToUserClose();
          }
        })
        .catch((err) => {
          console.error(err, err.stack);
        });
    }

    thisObj.setState({
      isLoading: false,
    });

    await this.allDigitalForm();
  }
  updateDate = (Guid) => {
    API.post("updateemaildate", "/updateemaildate", {
      body: {
        guid: Guid,
        Timestamp: moment(),
      },
    })
      .then((data) => {
        console.log(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  showProjectedUsers() {
    let projectedUsersarray = [];
    let projectedUsers = this.state.projectedUsers;
    if (this.state.projectedUsers.length > 0) {
      projectedUsers.map((results, key) => {
        projectedUsersarray.push(
          <option
            key={key}
            data-phone={results.MobileNumber}
            data-rname={
              results.FirstName +
              " " +
              (results.LastName !== null ? results.LastName : "")
            }
            data-email={results.EmailAddress}
            value={results.Guid}
          >
            {results.FirstName +
              " " +
              (results.LastName !== null ? results.LastName : "")}
          </option>
        );
        return null;
      });
      return projectedUsersarray;
    } else {
      return null;
    }
  }

  handleProjectedUsersSelect(event) {
    if (event.target.value.length > 0) {
      this.setState({
        selectProjectedUserError: "",
      });
      var projectedUsersEmail = $(
        'select[name="' + event.target.name + '"] :selected'
      ).attr("data-email");
      var projectedUsersName = $(
        'select[name="' + event.target.name + '"] :selected'
      ).attr("data-rname");
      var projectedUsersPhone = $(
        'select[name="' + event.target.name + '"] :selected'
      ).attr("data-phone");

      this.setState({
        formpackReceiverEmail: projectedUsersEmail,
        formpackReceiverRname: projectedUsersName,
        formpackReceiverRphone: projectedUsersPhone,
        formpackReceiverGuid: event.target.value,
      });
    } else {
      this.setState({
        selectProjectedUserError: "Please Select User.",
        formpackReceiverEmail: "",
        formpackReceiverGuid: "",
        formpackReceiverRname: "",
        formpackReceiverRphone: "",
      });
    }
  }

  handleSendLinkToUserClose() {
    this.setState({
      selectProjectedUserError: "",
      formpackReceiverEmail: "",
      formpackReceiverRname: "",
      formpackReceiverRphone: "",
      formpackReceiverGuid: "",
      formpacksendableGuid: "",
      handleSendLinkToUserShow: false,
    });
  }

  getDigitalFormByGuid(Guid) {
    var digitalForms = this.state.digitalFormCompleteData;
    //alert(digitalForms[0].guid);
    //return digitalForms;
    for (var i = digitalForms.length - 1; i >= 0; i--) {
      // look for the entry with a matching `code` value
      if (digitalForms[i].Guid === Guid) {
        // we found it
        return digitalForms[i];
      }
    }
    return null;
  }

  sendDocument = async (Guid) => {
    this.setState({ isLoading: true });
    var formData = this.getDigitalFormByGuid(Guid);

    var CurrentApprovalSeq =
      formData.ApprovalChain.length > 0
        ? formData.ApprovalChain[0].Sequence
        : "1";
    //console.log('CurrentApprovalSeq: ',CurrentApprovalSeq);
    var CurrentApproval = [];
    var externalSigner = false;

    formData.ApprovalChain.map(function (approver, index) {
      /*if(approver.userGuid === 'external-signer'){
           externalSigner = true;
      }*/
      if (approver.Sequence === CurrentApprovalSeq) {
        CurrentApproval.push(approver);
      }
    });

    //console.log('CurrentApproval: ',CurrentApproval); return false;

    var NewActivity = {
      Description: "Sent Digital Form to Approver.",
      IPAddress: this.state.ipv4,
      Timestamp: moment().unix(),
      Type: "SendDigitalForm",
      User: localStorage.getItem("userName"),
      profile_pic_url: localStorage.getItem("profile_pic_url"),
    };
    var Activity = formData.Activity;
    Activity.push(NewActivity);

    var body = {
      Guid: formData.Guid,
      updateAction: "SendDocument",
      Activity: Activity,
      ApprovalChain: formData.ApprovalChain,
      ApprovalGroup: formData.ApprovalGroup,
      ApprovalGroupguid: formData.ApprovalGroupguid,
      FormpackGuid: formData.FormpackGuid,
      Comments: formData.Comments,
      CreatedTS: formData.CreatedTS,
      CurrentApproval: CurrentApproval,
      CurrentApprovalSeq: parseInt(CurrentApprovalSeq),
      CustomFields: formData.CustomFields,
      Documents: formData.Documents,
      Email: formData.Email,
      EmpGuid: formData.EmpGuid,
      ExtSigners: formData.ExtSigners,
      FirstName: formData.FirstName,
      FormPack: formData.FormPack,
      LastName: formData.LastName,
      CountryCode: formData.CountryCode,
      Mobile: formData.Mobile,
      Timestamp: formData.Timestamp,
      UserName: formData.UserName,
      ProjectName: formData.ProjectName ? formData.ProjectName : "",
      ProjectGuid: formData.ProjectGuid ? formData.ProjectGuid : "",
    };

    if (
      CurrentApproval[0]?.userGuid === "external-signer" &&
      formData.ExtSigners.length > 0
    ) {
      var emailTemplate = this.getDefaultEmailContent("New Contract");
      if (emailTemplate) {
        this.sendLinkToSigner(body, emailTemplate);
      } else {
        toast.error("Default email template not exist.", { autoClose: 5000 });
      }
    } else {
      var emailTemplate = this.getDefaultEmailContent("Forms submitted");
      if (emailTemplate) {
        this.sendLinkToApprovers(body, emailTemplate);
      } else {
        toast.error("Default email template not exist.", { autoClose: 5000 });
      }

      this.updateDigitlForms(body)
        .then((res) => {
          if (res.status) {
            $(".docdetail").hide();
            this.allDigitalForm();
            //this.uploadPDFDocs(body);
            toast.success("Success! Sent to Aprover", { autoClose: 5000 });
          } else {
            toast.error("Error in sending, please try again later", {
              autoClose: 5000,
            });
          }
          //this.setState({ isLoading:false });
        })
        .catch((err) => {
          toast.error("Error in sending, please try again later", {
            autoClose: 5000,
          });
          this.setState({ isLoading: false });
        });
    }
  };

  sendLinkToApprovers = async (formData, emailTemplate) => {
    //console.log('emailTemplate=>', emailTemplate);
    var subject = emailTemplate.Subject;
    var BodyText = emailTemplate.BodyText;
    var message = emailTemplate.BodyText;
    var returned_data = {
      to: "",
      message: message,
    };

    formData.CurrentApproval.map(async (approver) => {
      //console.log('approver guid=>', approver);
      returned_data = await this.replacePlaceHodler(message, approver.userGuid);

      this.sendEmailToSigner(returned_data.to, subject, returned_data.message)
        .then((data) => {
          if (data.status === true) {
            toast.success("Email has been sent to approvers successfully", {
              autoClose: 5000,
            });
          } else {
            toast.error("Error in sending email, please try again later", {
              autoClose: 5000,
            });
            this.setState({ isLoading: false });
          }
        })
        .catch((err) => {
          console.error(err, err.stack);
          this.setState({ isLoading: false });
        });
    });
  };

  sendLinkToSigner = async (formData, emailTemplate) => {
    var ExtSignerData = formData.ExtSigners.find((e) => e.Signed !== 1);
    var CustomFields = formData.CustomFields;
    var ExtSignerName =
      ExtSignerData?.FirstName + " " + ExtSignerData?.Lastname;
    var ccEmail = null;
    var ExText = "";

    var subject = emailTemplate.Subject;
    var BodyText = emailTemplate.BodyText;
    var message = emailTemplate.BodyText;
    //console.log('send form External: ', ExtSignerData); return false;

    try {
      let user_data = await this.props.postRequest("/users/get-by-email", {
        userEmail: ExtSignerData?.Email,
        companyGuid: localStorage.getItem("companyGuid"),
      });
      if (user_data.status) {
        this.setState({ Rguid_user: user_data.guid });
      } else {
        this.setState({ Rguid_user: null });
      }
    } catch (err) {
      this.setState({ Rguid_user: null });
    }

    await this.recordOnlineFormData(
      this.state.Rguid_user,
      ExtSignerName,
      ExtSignerData?.Email,
      ExtSignerData?.Mobile,
      formData.Guid,
      "SendableUrl",
      formData.UserName
    )
      .then(async (data) => {
        //console.log('record ling=>',data);
        if (data.status === true) {
          var SendableUrl = this.LinkOfProjectedUser(data.guid, ExtSignerName);

          //console.log('SendableUrl: ', SendableUrl);
          message = await this.replaceExternalPartyPlaceHolder(
            message,
            ExtSignerData,
            data.guid,
            CustomFields
          );

          this.sendEmailToSigner(ExtSignerData.Email, subject, message)
            .then((data) => {
              if (data.status === true) {
                //toast.success("Success! Email has been sent successfully", { autoClose: 5000 });

                this.updateDigitlForms(formData)
                  .then((res) => {
                    if (res.status) {
                      $(".docdetail").hide();
                      this.allDigitalForm();
                      //this.uploadPDFDocs(formData);
                      toast.success("Success! Sent to approver", {
                        autoClose: 5000,
                      });
                    } else {
                      toast.error(
                        "Error in sending to approver, please try again later",
                        { autoClose: 5000 }
                      );
                    }
                    this.setState({ isLoading: false });
                  })
                  .catch((err) => {
                    //console.log('Error in Email: ',err);
                    toast.error(
                      "Error in sending to approver, please try again later",
                      { autoClose: 5000 }
                    );
                    this.setState({ isLoading: false });
                  });
              } else {
                toast.error("Error in sending email, please try again later", {
                  autoClose: 5000,
                });
                this.setState({ isLoading: false });
              }
            })
            .catch((err) => {
              console.error(err, err.stack);
              this.setState({ isLoading: false });
            });
        } else {
          toast.error("Error in Recording link, please try again later", {
            autoClose: 5000,
          });
          this.setState({ isLoading: false });
        }
      })
      .catch((err) => {
        console.log("eeee -", err);
        toast.error("Error in Recording link, please try again later", {
          autoClose: 5000,
        });
        this.setState({ isLoading: false });
      });
  };
  //End sendLinkToSigner

  updateDigitlForms(body) {
    return this.props.postRequest("/documents/update-document", body);
  }

  getDefaultEmailContent(type) {
    var emailTemplateDate = false;
    this.state.EmailTemplates.filter((item) => {
      if (item.Default === 1 && item.Type === type) {
        emailTemplateDate = item;
      }
    });
    return emailTemplateDate;
  }

  sendEmailApproved = async (formData, attachments, distributions) => {
    //console.log("attachments=>", attachments); return false;

    var emailTemplate = this.getDefaultEmailContent("Forms Approved");
    if (emailTemplate) {
      var subject = emailTemplate.Subject;
      var BodyText = emailTemplate.BodyText;
      var message = emailTemplate.BodyText;
      var returned_data = {
        to: "",
        message: message,
      };

      returned_data = await this.replacePlaceHodler(message, formData.EmpGuid);
      this.sendEmailToSigner(
        returned_data.to,
        subject,
        returned_data.message,
        attachments
      )
        .then((data) => {
          console.log(
            "email sent to opreator at " + returned_data.to + "=>",
            data
          );
        })
        .catch((err) => {
          console.error(err, err.stack);
        });

      if (distributions) {
        await Promise.all(
          Object.keys(distributions).map(async (distributionEmail) => {
            try {
              await this.sendEmailToSigner(
                distributionEmail,
                subject,
                message,
                distributions[distributionEmail]
              );
              console.log(
                `email sent to distribution ${distributionEmail} with ${distributions[distributionEmail].length} attachments`
              );
            } catch (error) {
              console.log(
                `Failed to send email to distribution ${distributionEmail}`
              );
            }
            return true;
          })
        );
      }
    } else {
      toast.error("Default email template for Forms Approved does not exist.", {
        autoClose: 5000,
      });
    }
    //console.log('External Party Email Template=>', ExternalPartyEmailTemplate);

    const ExternalPartyEmailTemplate = this.getDefaultEmailContent(
      "External Party Approved"
    );
    if (ExternalPartyEmailTemplate) {
      const subject = ExternalPartyEmailTemplate.Subject;
      let message = ExternalPartyEmailTemplate.BodyText;
      let originalMessage = ExternalPartyEmailTemplate.BodyText;

      formData.ExtSigners.map(async (signer) => {
        //console.log("signer=>", signer);
        var Email = signer.Email;
        if (signer.fpUserEmail) {
          //console.log("fpAccountCheck User=>", userData.Item);

          attachments.map((attachment) => {
            //console.log("attachment=>", attachment);
            this.uploadDocumentFP(
              attachment.content,
              signer.fpUserGuid,
              signer.fpUserRegion
            )
              .then((docData) => {
                console.log("uploadDocumentFP Doc Data=>", docData);
              })
              .catch((err) => {
                console.log("uploadDocumentFP Error=>", err);
              });
          });

          message = await this.replaceExternalPartyPlaceHolder(
            originalMessage,
            signer,
            false,
            false
          );
          //console.log('message=>', message);

          this.sendEmailToSigner(
            signer.fpUserEmail,
            subject,
            message,
            attachments
          )
            .then((data) => {
              console.log("email sent to fp user " + Email + "=>", data);
            })
            .catch((err) => {
              console.error(err, err.stack);
            });
        }
        message = await this.replaceExternalPartyPlaceHolder(
          originalMessage,
          signer,
          false,
          false
        );

        this.sendEmailToNonFPUser(Email, subject, message, attachments)
          .then((emailData) => {
            if (emailData.status === true) {
              console.log("email sent to non fp user=>", emailData);
            } else {
              console.log("sendEmailToNonFPUser error=>", emailData);
              //toast.error("Error in sending Email, please try again later", { autoClose: 5000});
            }
          })
          .catch((err) => {
            console.log("sendEmailToNonFPUser error=>", err);
          });
      });
    } else {
      toast.error(
        "Default email template for External Party Approved does not exist.",
        { autoClose: 5000 }
      );
    }
  };

  replaceExternalPartyPlaceHolder = async (
    message,
    signer,
    linkGuid,
    CustomFields
  ) => {
    let word = /\{{(.*?)\}}/g;
    let tempArray = [];
    let responceplaceHolder = "";
    let placeHolderArray = [];
    let tagsArray = [];

    for (let m = word.exec(message); m; m = word.exec(message)) {
      placeHolderArray.push(m[1]);
    }

    try {
      var response = await this.props.postRequest(
        "/email-templates/get-placeholder-data",
        {
          placeholderNames: [...placeHolderArray, "ContractLink"],
          companyGuid: localStorage.getItem("companyGuid"),
          formRecordGuid: this.state.CurrentForm.Guid,
          ofLinkGuid: linkGuid || undefined,
        }
      );
      if (response.status) {
        responceplaceHolder = response.placeholders;
        responceplaceHolder.map((items) => {
          const replaceKey = "{{" + items.name + "}}";
          message = message.split(replaceKey).join(items.value);
        });

        return message;
      } else {
        return message;
      }
    } catch (err) {
      console.log("email-placeholders/get-placeholder-data Error=>", err);
      return message;
    }
  };

  replacePlaceHodler = async (message, guid) => {
    let word = /\{{(.*?)\}}/g;
    let tempArray = [];
    let responceplaceHolder = "";
    let userData = {};
    var output = {
      to: "",
      message: "",
    };

    for (let m = word.exec(message); m; m = word.exec(message)) {
      this.state.placeHolderArray.push(m[1]);
    }

    try {
      var user_response = await this.props.postRequest(
        "/users/getsingleuserguid",
        { Guid: guid }
      );
      if (user_response.status) {
        userData = {
          ...user_response.result,
          CompanyID: localStorage.getItem("companyID"),
        };
        output.to = user_response.result.EmailAddress;
      }

      var response = await this.props.postRequest(
        "/email-templates/get-placeholder-data",
        {
          placeholderNames: this.state.placeHolderArray,
          companyGuid: localStorage.getItem("companyGuid"),
          formRecordGuid: this.state.CurrentForm.Guid,
        }
      );
      if (response.status) {
        responceplaceHolder = response.placeholders;
        responceplaceHolder.map((items) => {
          var replaceKey = "{{" + items.name + "}}";
          message = message.split(replaceKey).join(items.value);
        });

        output.message = message;
        return output;
      } else {
        output.message = message;
        return output;
      }
    } catch (err) {
      console.log("email-placeholders/get-email-placeholders Error=>", err);
      output.message = message;
      return output;
    }
  };

  approveForm = async (event) => {
    event.preventDefault();
    this.setState({ isLoading: true });
    var externalSigner = false;
    var formData = this.state.CurrentForm;
    var ApprovalChain = [];
    var CurrentApprovalSeq = parseInt(formData.CurrentApprovalSeq);
    var signatureCheckFailed = false;

    //console.log("current formData=>", formData);
    var NextApproval = [];
    await Promise.all(
      formData.ApprovalChain.map(async (approver) => {
        if (CurrentApprovalSeq === parseInt(approver.Sequence)) {
          const signatures = await this.props.postRequest(
            "/attachments/get-signature",
            {
              CompanyGuid: localStorage.getItem("companyGuid"),
              CompanyId: localStorage.getItem("companyID"),
              tenantGuid: localStorage.getItem("currentTenantGuid"),
            }
          );

          if (
            !signatures.result.signature &&
            !signatures.result.typed_signature
          ) {
            toast.error(
              "No signatures found. Please set up your signature in the signature settings.",
              {
                autoClose: 5000,
              }
            );

            setTimeout(() => {
              this.props.history.push("/dashboard/signature-settings");
            }, 1000);
            signatureCheckFailed = true;
            return;
          }

          let signatureFileName = "SignatureFile.jpg";
          if (
            !signatures.result.signature &&
            signatures.result.typed_signature
          ) {
            signatureFileName = "SignatureFileTyped.jpg";
          }

          var approver_obj = {
            ApproverName: approver.ApproverName,
            Sequence: approver.Sequence,
            Signed: 1,
            SigPosition: approver.SigPosition,
            userGuid: approver.userGuid,
            AppIP: this.state.ipv4,
            AppTimeStamp: moment().unix(),
            signPath:
              "signatures/" +
              localStorage.getItem("currentTenantGuid") +
              "/" +
              approver.userGuid +
              `/${signatureFileName}`,
          };
          // TODO: check the type of signature TYPED or DRAWN
          ApprovalChain.push(approver_obj);
        } else {
          ApprovalChain.push(approver);
        }

        if (CurrentApprovalSeq + 1 === parseInt(approver.Sequence)) {
          NextApproval.push(approver);
        }
      })
    );
    if (signatureCheckFailed) {
      return;
    }
    //var currentApproverIndex = this.findFromJsonArray(formData.ApprovalChain, formData.CurrentApproval.userGuid, "userGuid");
    //var totalApprovals = formData.ApprovalChain.length;

    // console.log("------------",formData);
    if (NextApproval.length === 0) {
      var CurrentApproval = [];
      var CurrentApprovalSeq = 1;
      var Status = "Approved";
      var ApprovedDate = moment().format();
    } else {
      //ApprovalChain[currentApproverIndex].Signed = 1;
      var CurrentApproval = NextApproval;
      var CurrentApprovalSeq = CurrentApprovalSeq + 1;
      var Status = formData.Status;
      var ApprovedDate = moment().format();

      if (CurrentApproval[0].userGuid === "external-signer") {
        externalSigner = true;
      }
    }
    var NewActivity = {
      Description:
        "Approve Digital Form by " + localStorage.getItem("userName") + ".",
      IPAddress: this.state.ipv4,
      Timestamp: moment().unix(),
      Type: "ApproveDigitalForm",
      User: localStorage.getItem("userName"),
      profile_pic_url: localStorage.getItem("profile_pic_url"),
    };
    var Activity = formData.Activity;
    Activity.push(NewActivity);

    var body = {
      Guid: formData.Guid,
      updateAction: "ApproveDocument",
      Activity: Activity,
      ApprovalChain: ApprovalChain,
      ApprovalGroup: formData.ApprovalGroup,
      ApprovalGroupguid: formData.ApprovalGroupguid,
      FormpackGuid: formData.FormpackGuid,
      Comments: formData.Comments,
      CreatedTS: formData.CreatedTS,
      CurrentApproval: CurrentApproval,
      CurrentApprovalSeq: CurrentApprovalSeq,
      CustomFields: formData.CustomFields,
      Documents: formData.Documents,
      Email: formData.Email,
      EmpGuid: formData.EmpGuid,
      ExtSigners: formData.ExtSigners,
      FirstName: formData.FirstName,
      FormPack: formData.FormPack,
      LastName: formData.LastName,
      CountryCode: formData.CountryCode,
      Mobile: formData.Mobile,
      Status: Status,
      ApprovedDate: ApprovedDate,
      Timestamp: formData.Timestamp,
      UserName: formData.UserName,
      ProjectName: formData.ProjectName ? formData.ProjectName : "",
      ProjectGuid: formData.ProjectGuid ? formData.ProjectGuid : "",
      DFDocs: this.state.selectedDFDocs,
    };
    //this.uploadPDFDocs(body); return false;
    //console.log(body); return false;
    if (externalSigner) {
      var emailTemplate = this.getDefaultEmailContent("New Contract");
      if (emailTemplate) {
        this.sendLinkToSigner(body, emailTemplate);
      } else {
        toast.error("Default email template does not exist.", {
          autoClose: 5000,
        });
      }
    } else {
      if (Status === "Approved") {
        this.uploadPDFDocs(body);
      } else {
        var emailTemplate = this.getDefaultEmailContent("Forms submitted");
        if (emailTemplate) {
          this.sendLinkToApprovers(body, emailTemplate);
        } else {
          toast.error("Default email template does not exist.", {
            autoClose: 5000,
          });
        }
      }
      //return false;
      this.updateDigitlForms(body)
        .then((res) => {
          if (res.status) {
            this.allDigitalForm();
            //this.uploadPDFDocs(body);
            toast.success("Approved Successfully.", { autoClose: 5000 });
          } else {
            toast.error("Error in approve, please try again later", {
              autoClose: 5000,
            });
          }
          //this.setState({ isLoading:false });
        })
        .catch((err) => {
          toast.error("Error in approve, please try again later", {
            autoClose: 5000,
          });
          this.setState({ isLoading: false });
        });
    }
  };

  onAttachmentOpen = async (attachments) => {
    console.log(attachments);
    await this.setState({
      selectedAttachments: attachments,
    });
  };

  async updateCurrentForm(Guid) {
    //event.preventDefault();
    //alert(Guid +"==="+ this.state.CurrentForm.guid);
    if (Guid === this.state.CurrentForm?.Guid) {
      return false;
    }
    var formData = this.getDigitalFormByGuid(Guid);
    this.setState({ CurrentForm: formData }, () => {
      this.setPDFPreviews(formData.Guid);
    });
  }

  declineForm = async (event) => {
    event.preventDefault();
    //alert('abc')
    this.setState({ isLoading: true });
    var formData = this.state.CurrentForm;

    var NewActivity = {
      Description: "Decline Digital Form.",
      IPAddress: this.state.ipv4,
      Timestamp: moment().unix(),
      Type: "DeclineDigitalForm",
      User: localStorage.getItem("userName"),
      profile_pic_url: localStorage.getItem("profile_pic_url"),
    };
    var Activity = formData.Activity;
    Activity.push(NewActivity);

    var body = {
      Guid: formData.Guid,
      updateAction: "ApproveDocument",
      Activity: Activity,
      ApprovalChain: formData.ApprovalChain,
      ApprovalGroup: formData.ApprovalGroup,
      ApprovalGroupguid: formData.ApprovalGroupguid,
      FormpackGuid: formData.FormpackGuid,
      Comments: formData.Comments,
      CreatedTS: formData.CreatedTS,
      CurrentApproval: formData.CurrentApproval,
      CurrentApprovalSeq: formData.CurrentApprovalSeq,
      CustomFields: formData.CustomFields,
      Documents: formData.Documents,
      Email: formData.Email,
      EmpGuid: formData.EmpGuid,
      ExtSigners: formData.ExtSigners,
      FirstName: formData.FirstName,
      FormPack: formData.FormPack,
      LastName: formData.LastName,
      CountryCode: formData.CountryCode,
      Mobile: formData.Mobile,
      Status: "Declined",
      ApprovedDate: moment().format(),
      Timestamp: formData.Timestamp,
      UserName: formData.UserName,
      ProjectName: formData.ProjectName ? formData.ProjectName : "",
      ProjectGuid: formData.ProjectGuid ? formData.ProjectGuid : "",
      DeclinedReason: this.state.DeclineText,
    };
    //console.log('Move to draft: ',body); return false;
    this.updateDigitlForms(body)
      .then((res) => {
        if (res.status) {
          this.allDigitalForm();
          this.setState({ declineModalOpen: false });
          toast.success("Document has been declined Successfully", {
            autoClose: 5000,
          });

          this.sendEmailOnDecline(formData);
        } else {
          console.log("Error in decline=>", res);
          toast.error("Error in decline, please try again later", {
            autoClose: 5000,
          });
        }
        this.setState({ isLoading: false, DeclineText: "" });
      })
      .catch((err) => {
        console.log("Error in decline=>", err);
        toast.error("Error in decline, please try again later", {
          autoClose: 5000,
        });
        this.setState({ isLoading: false });
      });
  };

  async moveFormToDraft(event) {
    event.preventDefault();
    //alert('abc')
    this.setState({ isLoading: true });
    var formData = this.state.CurrentForm;
    //console.log(formData); return false;

    //var currentApproverIndex = this.findFromJsonArray(formData.ApprovalChain, formData.CurrentApproval.userGuid, "userGuid");
    //var totalApprovals = formData.ApprovalChain.length;
    var ApprovalChain = await this.resetApprovalChain(formData.ApprovalChain);
    var ExtSigners = await this.resetExtSigners(formData.ExtSigners);
    var CurrentApproval = [];
    var CurrentApprovalSeq = "1";
    var Status = "Draft";

    //console.log(ApprovalChain); return false;

    var NewActivity = {
      Description: "Move Digital Form to draft.",
      IPAddress: this.state.ipv4,
      Timestamp: moment().unix(),
      Type: "MoveDigitalForm",
      User: localStorage.getItem("userName"),
      profile_pic_url: localStorage.getItem("profile_pic_url"),
    };
    var Activity = formData.Activity;
    Activity.push(NewActivity);

    var body = {
      Guid: formData.Guid,
      updateAction: "ApproveDocument",
      Activity: Activity,
      ApprovalChain: ApprovalChain,
      ApprovalGroup: formData.ApprovalGroup,
      ApprovalGroupguid: formData.ApprovalGroupguid,
      FormpackGuid: formData.FormpackGuid,
      Comments: formData.Comments,
      CreatedTS: formData.CreatedTS,
      CurrentApproval: CurrentApproval,
      CurrentApprovalSeq: CurrentApprovalSeq,
      CustomFields: formData.CustomFields,
      Documents: formData.Documents,
      Email: formData.Email,
      EmpGuid: formData.EmpGuid,
      ExtSigners: ExtSigners,
      FirstName: formData.FirstName,
      FormPack: formData.FormPack,
      LastName: formData.LastName,
      CountryCode: formData.CountryCode,
      Mobile: formData.Mobile,
      Status: Status,
      ApprovedDate: moment().format(),
      Timestamp: formData.Timestamp,
      UserName: formData.UserName,
      ProjectName: formData.ProjectName ? formData.ProjectName : "",
      ProjectGuid: formData.ProjectGuid ? formData.ProjectGuid : "",
    };
    //console.log('Move to draft: ',body); return false;
    await this.updateDigitlForms(body)
      .then((res) => {
        if (res.status) {
          this.allDigitalForm();
          toast.success("Moved to draft Successfully", { autoClose: 5000 });
        } else {
          toast.error("Error in moving, please try again later", {
            autoClose: 5000,
          });
        }
        //this.setState({ isLoading:false });
      })
      .catch((err) => {
        toast.error("Error in moving, please try again later", {
          autoClose: 5000,
        });
        this.setState({ isLoading: false });
      });
  }

  resetApprovalChain(ApprovalChain) {
    var approvels = [];
    ApprovalChain.map(function (approver, index) {
      approvels.push({
        ApproverName: approver.ApproverName,
        Sequence: approver.Sequence,
        Signed: 0,
        SigPosition: approver.SigPosition,
        userGuid: approver.userGuid,
        AppIP: null,
        AppTimeStamp: null,
        signPath: null,
      });
    });
    return approvels;
  }

  resetExtSigners(ExtSigners) {
    var signers = [];
    ExtSigners.map(function (signer, index) {
      signers.push({
        countryCode: signer.countryCode,
        Email: signer.Email,
        ExtIP: null,
        ExtTimeStamp: null,
        FirstName: signer.FirstName,
        Lastname: signer.Lastname,
        Mobile: signer.Mobile,
        Sequence: signer.Sequence,
        Signed: 0,
        signPath: null,
        SigPosition: signer.SigPosition,
      });
    });
    return signers;
  }

  async handleSendLinkToUserOpen(Guid) {
    this.setState({
      isLoading: true,
      formpacksendableGuid: Guid,
    });
    await API.post("projectedusers", "/projectedusers")
      .then((data) => {
        this.setState({
          projectedUsers: data,
        });
      })
      .catch((err) => {
        console.error(err, err.stack);
      });
    this.setState({
      handleSendLinkToUserShow: true,
      isLoading: false,
    });
  }

  allDocumentsFormAPI(array) {
    console.log(array);
    return API.post("getdfdocs", "/getdfdocs", {
      body: {
        formguids: array,
      },
    });
  }

  edit_document = (id) => {
    this.props.history.push("/dashboard/insert-document", { edit_id: id });
  };

  allDigitalForm() {
    //console.log("allDigitalForm=>"); return false;
    this.setState({ isLoading: true });
    let temp_digitalFormGuids = [];
    this.allDigitalFormAPI()
      .then((response) => {
        if (!response.status) {
          this.setState({ isLoading: true });
          toast.error(response.error, { autoClose: 5000 });
          return false;
        }
        const data = response.result;
        //console.log("allDigitalForm data=>", data); return false;
        data.map((val) => {
          temp_digitalFormGuids.push(val.guid);
        });

        this.setState(
          {
            digitalFormGuids: temp_digitalFormGuids,
            digitalFormCompleteData: data,
            digitalFormCompleteDataSearch: data,
          },
          () => {
            let approve = 0,
              approved = 0,
              declined = 0,
              draft = 0,
              pending = 0,
              otherApprove = 0;
            var approverForms = [],
              approvedForms = [],
              declinedForms = [],
              draftForms = [],
              pendingForms = [],
              allForms = [];

            this.state.digitalFormCompleteData.map((val) => {
              if (localStorage.getItem("userType") === "Operator/Approver") {
                if (val.Status === "Draft") {
                  if (val.EmpGuid === localStorage.getItem("Guid")) {
                    draft++;
                    draftForms.push(val);
                    allForms.push(val);
                  }
                }

                var counted = false;
                if (val.Status === "Pending") {
                  if (val.EmpGuid === localStorage.getItem("Guid")) {
                    pending++;
                    pendingForms.push(val);
                    allForms.push(val);
                    counted = true;

                    /*var ApprovalChain = val.ApprovalChain;

                for (var j = 0; j < ApprovalChain.length; j++) {
                  if(ApprovalChain[j].userGuid === localStorage.getItem('Guid')){
                    approve++;
                    approverForms.push(val);
                  }
                }*/
                  } else {
                    var ApprovalChain = val.ApprovalChain;

                    for (var j = 0; j < ApprovalChain.length; j++) {
                      if (
                        ApprovalChain[j].userGuid ===
                        localStorage.getItem("Guid")
                      ) {
                        pending++;
                        pendingForms.push(val);
                        allForms.push(val);
                        counted = true;
                      }
                    }
                  }
                }

                if (val.Status === "Pending") {
                  var isCurrentApprover = this.isCurrentApprover(
                    val.CurrentApproval
                  );

                  if (isCurrentApprover) {
                    approve++;
                    approverForms.push(val);
                    if (!counted) {
                      allForms.push(val);
                    }
                  }
                }

                if (val.Status === "Declined") {
                  if (val.EmpGuid === localStorage.getItem("Guid")) {
                    declined++;
                    declinedForms.push(val);
                    allForms.push(val);
                  } else {
                    var ApprovalChain = val.ApprovalChain;

                    for (var j = 0; j < ApprovalChain.length; j++) {
                      if (
                        ApprovalChain[j].userGuid ===
                        localStorage.getItem("Guid")
                      ) {
                        declined++;
                        declinedForms.push(val);
                        allForms.push(val);
                      }
                    }
                  }
                }

                if (val.Status === "Approved") {
                  if (val.EmpGuid === localStorage.getItem("Guid")) {
                    approved++;
                    approvedForms.push(val);
                    allForms.push(val);
                  } else {
                    var ApprovalChain = val.ApprovalChain;

                    for (var j = 0; j < ApprovalChain.length; j++) {
                      if (
                        ApprovalChain[j].userGuid ===
                        localStorage.getItem("Guid")
                      ) {
                        approved++;
                        approvedForms.push(val);
                        allForms.push(val);
                      }
                    }
                  }
                }
              } //End Operator/Approver

              if (localStorage.getItem("userType") === "Approver") {
                var counted = false;

                if (val.Status === "Pending") {
                  var ApprovalChain = val.ApprovalChain;

                  for (var j = 0; j < ApprovalChain.length; j++) {
                    if (
                      ApprovalChain[j].userGuid === localStorage.getItem("Guid")
                    ) {
                      pending++;
                      pendingForms.push(val);
                      allForms.push(val);
                      counted = true;
                    }
                  }
                }

                if (val.Status === "Pending") {
                  var isCurrentApprover = this.isCurrentApprover(
                    val.CurrentApproval
                  );

                  if (isCurrentApprover) {
                    approve++;
                    approverForms.push(val);
                    if (!counted) {
                      allForms.push(val);
                    }
                  }

                  /*                        var ApprovalChain = val.ApprovalChain;

                                      for (var j = 0; j < ApprovalChain.length; j++) {
                                        if(ApprovalChain[j].userGuid === localStorage.getItem('Guid')){
                                          approve++;
                                          pending++;
                                          approverForms.push(val);
                                          allForms.push(val);
                                        }
                                      }*/
                }

                if (val.Status === "Declined") {
                  var ApprovalChain = val.ApprovalChain;

                  for (var j = 0; j < ApprovalChain.length; j++) {
                    if (
                      ApprovalChain[j].userGuid === localStorage.getItem("Guid")
                    ) {
                      declined++;
                      declinedForms.push(val);
                      allForms.push(val);
                    }
                  }
                }

                if (val.Status === "Approved") {
                  var ApprovalChain = val.ApprovalChain;

                  for (var j = 0; j < ApprovalChain.length; j++) {
                    if (
                      ApprovalChain[j].userGuid === localStorage.getItem("Guid")
                    ) {
                      approved++;
                      approvedForms.push(val);
                      allForms.push(val);
                    }
                  }
                }
              } //End Approver

              if (localStorage.getItem("userType") === "Operator") {
                if (val.Status === "Draft") {
                  if (val.EmpGuid === localStorage.getItem("Guid")) {
                    draft++;
                    draftForms.push(val);
                    allForms.push(val);
                  }
                }

                if (val.Status === "Pending") {
                  if (val.EmpGuid === localStorage.getItem("Guid")) {
                    pending++;
                    pendingForms.push(val);
                    allForms.push(val);
                  }
                }

                if (val.Status === "Declined") {
                  if (val.EmpGuid === localStorage.getItem("Guid")) {
                    declined++;
                    declinedForms.push(val);
                    allForms.push(val);
                  }
                }

                if (val.Status === "Approved") {
                  if (val.EmpGuid === localStorage.getItem("Guid")) {
                    approved++;
                    approvedForms.push(val);
                    allForms.push(val);
                  }
                }
              } //End Operator

              if (
                localStorage.getItem("userType") === "SysAdmin" ||
                localStorage.getItem("userType") === "Admin"
              ) {
                if (val.Status === "Draft") {
                  draft++;
                  draftForms.push(val);
                  allForms.push(val);
                }

                if (val.Status === "Pending") {
                  pending++;
                  pendingForms.push(val);
                  allForms.push(val);
                }

                if (val.Status === "Approve") {
                  approve++;
                  approverForms.push(val);
                  //allForms.push(val);
                }

                if (val.Status === "Declined") {
                  declined++;
                  declinedForms.push(val);
                  allForms.push(val);
                }

                if (val.Status === "Approved") {
                  approved++;
                  approvedForms.push(val);
                  allForms.push(val);
                }
              } //End SysAdmin and Admin
            });

            draftForms = getUniqueListBy(draftForms, "Guid");
            pendingForms = getUniqueListBy(pendingForms, "Guid");
            approverForms = getUniqueListBy(approverForms, "Guid");
            declinedForms = getUniqueListBy(declinedForms, "Guid");
            approvedForms = getUniqueListBy(approvedForms, "Guid");
            allForms = getUniqueListBy(allForms, "Guid");

            this.setState({
              Approve: approverForms.length,
              Declined: declinedForms.length,
              Approved: approvedForms.length,
              Draft: draftForms.length,
              Pending: pendingForms.length,
              otherApprove: otherApprove,
              draftForms: draftForms,
              draftFormsCompleteDataSearch: draftForms,
              pendingForms: pendingForms,
              pendingFormsCompleteDataSearch: pendingForms,
              approverForms: approverForms,
              approverFormsCompleteDataSearch: approverForms,
              declinedForms: declinedForms,
              declinedFormsCompleteDataSearch: declinedForms,
              approvedForms: approvedForms,
              approvedFormsCompleteDataSearch: approvedForms,
              allForms: allForms,
              allFormsCompleteDataSearch: allForms,
            });
            setTimeout(
              function () {
                this.setCurrentForm(this.state.CurrentTab);
              }.bind(this),
              1000
            );

            /*this.allDocumentsFormAPI(this.state.digitalFormGuids).then(data =>{
            this.setState({
                documents: data.result
            })
        })*/
          }
        );
      })
      .catch((err) => {
        this.setState({ isLoading: true });
        toast.error(err.message, { autoClose: 5000 });
        console.log("Error in getting Forms: ", err);
      });
  }

  allDigitalFormAPI = (event) => {
    return this.props.postRequest("/documents/get-list", {
      CompanyGuid: localStorage.getItem("companyGuid"),
      summarize: true,
    });
  };

  search = (event) => {
    if (this.state.CurrentTab === "All") {
      var text = event.target.value;
      this.setState({ search: event.target.value });
      this.setState({
        allForms: this.state.allFormsCompleteDataSearch.filter(function (
          person
        ) {
          var p_name = person.FirstName + " " + person.LastName;
          return p_name.toUpperCase().includes(text.toUpperCase());
        }),
      });
    } else if (this.state.CurrentTab === "Approved") {
      var text = event.target.value;
      this.setState({ search: event.target.value });
      this.setState({
        approvedForms: this.state.approvedFormsCompleteDataSearch.filter(
          function (person) {
            var p_name = person.FirstName + " " + person.LastName;
            return p_name.toUpperCase().includes(text.toUpperCase());
          }
        ),
      });
    } else if (this.state.CurrentTab === "Declined") {
      var text = event.target.value;
      this.setState({ search: event.target.value });
      this.setState({
        declinedForms: this.state.declinedFormsCompleteDataSearch.filter(
          function (person) {
            var p_name = person.FirstName + " " + person.LastName;
            return p_name.toUpperCase().includes(text.toUpperCase());
          }
        ),
      });
    } else if (this.state.CurrentTab === "Pending") {
      var text = event.target.value;
      this.setState({ search: event.target.value });
      this.setState({
        pendingForms: this.state.pendingFormsCompleteDataSearch.filter(
          function (person) {
            var p_name = person.FirstName + " " + person.LastName;
            return p_name.toUpperCase().includes(text.toUpperCase());
          }
        ),
      });
    } else if (this.state.CurrentTab === "Approve") {
      var text = event.target.value;
      this.setState({ search: event.target.value });
      this.setState({
        approverForms: this.state.approverFormsCompleteDataSearch.filter(
          function (person) {
            var p_name = person.FirstName + " " + person.LastName;
            return p_name.toUpperCase().includes(text.toUpperCase());
          }
        ),
      });
    }
  };

  searchDrafts = (event) => {
    var text = event.target.value;
    this.setState({ search: event.target.value });
    this.setState({
      draftForms: this.state.draftFormsCompleteDataSearch.filter(function (
        person
      ) {
        var p_name = person.FirstName + " " + person.LastName;
        return p_name.toUpperCase().includes(text.toUpperCase());
      }),
    });
  };

  moreDetailsModalClose() {
    this.setState({
      moreDetailsModalOpen: false,
    });
  }

  uploadPDFDocs = async (formData) => {
    // console.log("upload formData=>", formData); return false;
    var that = this;
    var signaturs = {};

    if (formData) {
      if (formData.ApprovalChain.length > 0) {
        formData.ApprovalChain.map(function (approver, index) {
          //console.log("approver "+index+"=>", approver);
          if (approver.Signed) {
            signaturs[
              that.state.TempFilePath +
                "/AppBlank" +
                approver.SigPosition +
                ".jpg"
            ] = approver.signPath ?? "";
            signaturs["AppIP" + approver.SigPosition] = approver.AppIP
              ? approver.AppIP
              : "";
            signaturs["AppTimestamp" + approver.SigPosition] =
              approver.AppTimeStamp ? approver.AppTimeStamp : "";
          }
        });
      }

      if (formData.ExtSigners.length > 0) {
        formData.ExtSigners.map(function (signer, index) {
          //console.log("signer "+index+"=>", signer);
          if (signer.Signed) {
            signaturs[
              that.state.TempFilePath +
                "/ExtBlank" +
                signer.SigPosition +
                ".jpg"
            ] = signer.signPath ?? "";
            signaturs["ExtIP" + signer.SigPosition] = signer.ExtIP
              ? signer.ExtIP
              : "";
            signaturs["ExtTimestamp" + signer.SigPosition] = signer.ExtTimeStamp
              ? signer.ExtTimeStamp
              : "";
          }
        });
      }
      //console.log("Post Signature=>", this.state.Signatures);
    }

    var Guid = formData.Guid;
    if (Guid) {
      //console.log('Form data in did mount: ', Guid);
      const options = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      };
      await this.getMultipleDocs(Guid)
        .then(async (response) => {
          if (!response.status) {
            this.setState({ isLoading: true });
            toast.error(response.error, { autoClose: 5000 });
            return false;
          }
          var PdfDocsData = [];
          var attachments = [];
          const distributions = {};
          var attachment = {};
          var count = 0;
          await response.result.map(async (doc) => {
            //console.log('Doc data=>', doc);
            //count++;
            //console.log('count=>', count);
            var uploadPath =
              doc.TenantGuid + "/df-docs-pdf/" + doc.Guid + ".pdf";
            var Document =
              doc.CompanyGuid + "/" + doc.TenantGuid + "/" + doc.DigitalDoc;
            var DocDetails = doc.DocDetails ?? [];
            var CustomList = doc.CustomList ?? [];
            const signatureCoordinates = {};

            var jsObj = {};
            DocDetails.map((detail) => {
              if (detail.Type === "Date") {
                jsObj[detail.Tag] = detail.DefaultValue
                  ? moment(new Date(detail.DefaultValue)).format("DD/MM/YYYY")
                  : "";
              } else {
                jsObj[detail.Tag] = detail.DefaultValue
                  ? detail.DefaultValue
                  : "";
              }
              if (
                detail.Tag?.includes("AppBlank") ||
                detail.Tag?.includes("ExtBlank")
              ) {
                signatureCoordinates[`/coordinates/${detail.Tag}`] =
                  detail.DefaultValue;
              }
            });

            if (CustomList.length > 0) {
              CustomList.map((list) => {
                //jsObj[detail.Tag] = detail.DefaultValue? detail.DefaultValue : "";
                list.CustomFields.map((field) => {
                  if (
                    field.Prompt === "startDate" ||
                    field.Prompt === "endDate"
                  ) {
                    jsObj[field.Tag] = field.DefaultValue
                      ? moment(new Date(field.DefaultValue)).format(
                          "DD/MM/YYYY"
                        )
                      : "";
                  } else {
                    jsObj[field.Tag] = field.DefaultValue
                      ? field.DefaultValue
                      : "";
                  }
                });
              });
            }

            var pdfData = {
              ApiKey: window.config.PDF_API_KEY,
              Confidential: doc.Confidential,
              tags: jsObj,
              // signatures: this.state.Signatures,
              signatures: { ...signaturs, ...signatureCoordinates },
              tenantGuid: localStorage.getItem("currentTenantGuid"),
              companyGuid: localStorage.getItem("companyGuid"),
              digitalDoc: doc.DigitalDoc.split("/").pop(),
            };
            //console.log("pdfData=>", pdfData);
            //EmailDist = EmailDist.concat(doc.EmailDist.filter((item) => EmailDist.indexOf(item) < 0))

            await axios
              .post(
                `${window.config.PDF_API_URL}${
                  pdfData.digitalDoc.endsWith(".pdf") ? "/fill?py=1" : ""
                }`,
                pdfData,
                options
              )
              .then((res) => {
                if (res.data.PDFDocument !== undefined) {
                  //PdfDocsData.push(res.data.PDFDocument);
                  attachment = {
                    filename: new Date().getTime() + ".pdf",
                    content: res.data.PDFDocument.replace(
                      /^data:.+;base64,/,
                      ""
                    ),
                    encoding: "base64",
                  };
                  // this.postEmailDistlist(doc.EmailDist, attachment);
                  doc.EmailDist.forEach((email) => {
                    if (distributions[email]) {
                      distributions[email].push(attachment);
                    } else {
                      distributions[email] = [attachment];
                    }
                  });
                  attachments.push(attachment);
                  count++;
                  if (response.result.length === count) {
                    //console.log("email attachments 1=>", attachments);
                    this.sendEmailApproved(
                      formData,
                      attachments,
                      distributions
                    );
                  }
                } else {
                  count++;
                  if (response.result.length === count) {
                    //console.log("email attachments 2=>", attachments);
                    this.sendEmailApproved(
                      formData,
                      attachments,
                      distributions
                    );
                  }
                }
              })
              .catch((error) => {
                console.log(
                  "error----------------------------------------------------------------",
                  error
                );
                count++;
                if (response.result.length === count) {
                  //console.log("email attachments 3=>", attachments);
                  this.sendEmailApproved(formData, attachments, distributions);
                }
                console.log("pdf preview result error=>", error);
              });
          });
        })
        .catch((err) => {
          console.error("error in uploading multi docs: ", err);
        });
    } else {
      console.error("invalid guid");
    }
  };

  fpAccountCheck = (Email) => {
    return this.props.postRequest("/users/validate-fp-user", {
      EmailAddress: Email,
    });
  };

  uploadDocumentFP = (PDFDocument, userGuid, region) => {
    return this.props.postRequest("/documents/create-fp-document", {
      base64String: PDFDocument,
      UserGuid: userGuid,
      region,
    });
  };

  async sendEmailToNonFPUser(to, subject, msg, attachments) {
    var sendTo = to;

    return this.props.postRequest("/users/send-mail", {
      TO: sendTo,
      CC: "",
      MSG: msg,
      SUBJECT: subject,
      ExText: "",
      attachments: attachments,
    });
  }

  postEmailDistlist = (EmailDist, attachment) => {
    EmailDist.map((email) => {
      let subject = "Digital Forms Document Approved.";
      let message =
        "You are added in distribution list of the document(s), please see the attachment.";
      var attachments = [attachment];

      this.sendEmailToNonFPUser(email, subject, message, attachments)
        .then((emailData) => {
          if (emailData.status === true) {
            console.log("dist list email sent at " + email + "=>", emailData);
          } else {
            console.log("sendEmailToNonFPUser error=>", emailData);
            //toast.error("Error in sending Email , Please Try again later", { autoClose: 5000});
          }
        })
        .catch((err) => {
          console.log("sendEmailToNonFPUser error=>", err);
        });
    });
  };

  renderExternalSigner() {
    let extSigners = [...this.state.digitalForm.ExtSigners];
    let rows;
    if (extSigners) {
      rows = extSigners.map(function (signer, index) {
        return (
          <tr className="custom_field_tab">
            <td>{signer.Sequence}</td>
            <td>{signer.FirstName + " " + signer.Lastname}</td>
            <td>
              {signer.Signed === 1 ? (
                <img src={tic_black} width="18" height="13" alt="" />
              ) : (
                ""
              )}
            </td>
          </tr>
        );
      });
    } else {
      rows = "<tr>record not founds</tr>";
    }
    return rows;
  }

  renderApprovalChain() {
    let approvalChain = [...this.state.digitalForm.ApprovalChain];
    const extSigners = [
      ...this.state.digitalForm?.ExtSigners?.sort(
        (a, b) => parseInt(a.Sequence) - parseInt(b.Sequence)
      ),
    ];

    console.log("ext", extSigners);

    approvalChain = approvalChain
      .sort((a, b) => parseInt(a.Sequence) - parseInt(b.Sequence))
      .map((approver) => {
        if (approver.userGuid === "external-signer") {
          const externalUser = extSigners.shift();
          approver.Signed = externalUser?.Signed;
        }
        return approver;
      });

    let rows;
    if (approvalChain) {
      rows = approvalChain.map((approver, index) => {
        return (
          <tr className="custom_field_tab">
            <td>{approver.Sequence}</td>
            <td>{approver.ApproverName}</td>
            <td>
              {approver.Signed === 1 ? (
                <img src={tic_black} width="18" height="13" alt="" />
              ) : (
                ""
              )}
            </td>
          </tr>
        );
      });
    } else {
      rows = "<tr>record not founds</tr>";
    }
    return rows;
  }

  sortBy(event) {
    this.setState({
      sortBy: event.currentTarget.value,
    });

    if (event.currentTarget.value === "Asc") {
      if (this.state.CurrentTab === "All") {
        this.state.allForms.sort(function (a, b) {
          return a.CreatedTS - b.CreatedTS;
        });
      } else if (this.state.CurrentTab === "Approved") {
        this.state.approvedForms.sort(function (a, b) {
          return a.CreatedTS - b.CreatedTS;
        });
      } else if (this.state.CurrentTab === "Declined") {
        this.state.declinedForms.sort(function (a, b) {
          return a.CreatedTS - b.CreatedTS;
        });
      } else if (this.state.CurrentTab === "Pending") {
        this.state.pendingForms.sort(function (a, b) {
          return a.CreatedTS - b.CreatedTS;
        });
      } else if (this.state.CurrentTab === "Approve") {
        this.state.approverForms.sort(function (a, b) {
          return a.CreatedTS - b.CreatedTS;
        });
      }
    } else {
      if (this.state.CurrentTab === "All") {
        this.state.allForms.sort(function (a, b) {
          return b.CreatedTS - a.CreatedTS;
        });
      } else if (this.state.CurrentTab === "Approved") {
        this.state.approvedForms.sort(function (a, b) {
          return b.CreatedTS - a.CreatedTS;
        });
      } else if (this.state.CurrentTab === "Declined") {
        this.state.declinedForms.sort(function (a, b) {
          return b.CreatedTS - a.CreatedTS;
        });
      } else if (this.state.CurrentTab === "Pending") {
        this.state.pendingForms.sort(function (a, b) {
          return b.CreatedTS - a.CreatedTS;
        });
      } else if (this.state.CurrentTab === "Approve") {
        this.state.approverForms.sort(function (a, b) {
          return b.CreatedTS - a.CreatedTS;
        });
      }
    }
  }

  moreDetailsModalOpen(event) {
    var that = this;
    this.state.digitalFormCompleteData.find(function (el, index) {
      if (el.Guid === event.currentTarget.id) {
        that.setState({
          digitalForm: el,
          isDigitalFormExist: true,
        });
      }
      return null;
    });
    this.setState({ moreDetailsModalOpen: true });
  }

  declineModalOpen(event) {
    this.setState({
      declineModalOpen: true,
    });
  }

  declineModalClose(event) {
    this.setState({
      declineModalOpen: false,
    });
  }

  findFromJsonArray(data, val, key) {
    var index = data.findIndex(function (item, i) {
      return item[key] === val;
    });

    return index >= 0 ? index : false;
  }

  findNextApprover(ApprovelChain) {
    var nextApproverIndex = false;
    for (var i = 0; i < ApprovelChain.length; i++) {
      if (1 !== parseInt(ApprovelChain[i].Signed)) {
        return i;
      }
    }
  }

  isCurrentApprover(CurrentApprovel) {
    var CurrentApprover = false;
    for (var i = 0; i < CurrentApprovel.length; i++) {
      if (localStorage.getItem("Guid") === CurrentApprovel[i].userGuid) {
        return true;
      }
    }
    return CurrentApprover;
  }

  carouselInner(event) {
    var carousel;
    if (this.state.PDFreviews) {
      var totalDocs = this.state.PDFreviews.length;
      var _this = this;

      const filteredPDFreviews = this.state.PDFreviews.sort(function (
        obj1,
        obj2
      ) {
        return obj1.Order - obj2.Order;
      });

      carousel = filteredPDFreviews?.map((doc, key) => {
        let className = key === 0 ? "item active" : "item";

        //var PDFDocument = res.data.PDFDocument;
        var PDFDocumentSample =
          "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";

        return (
          <div className={className}>
            <div className="carousel-caption">
              <div className="pdf-doc-title">
                <p className="carousel-title">
                  {doc.Desc}{" "}
                  <span>
                    Document {key + 1} of {totalDocs}
                  </span>
                </p>
                <button
                  type="button"
                  className="btn btn-sm"
                  data-toggle="modal"
                  data-target="#myModal_aprove_tabattach"
                >
                  <img src={attach_gray} alt="" />
                  <span className="badge_custom">
                    {this.state.docAttachmentsCount +
                      this.state.doc_external_list.length}
                  </span>
                </button>
              </div>
              <img
                style={{
                  width: "80px",
                  height: "80px",
                  display: _this.state.showPreviewLoader
                    ? "inline-block"
                    : "none",
                }}
                src={loading_pdf_preview}
                className="profile_img"
                alt=""
              />
              <div className="pdfContainer">
                <object
                  data={"data:application/pdf;base64," + PDFDocument}
                  type="application/pdf"
                  style={{ width: "100%", height: "700px" }}
                >
                  <embed
                    src={"data:application/pdf;base64," + PDFDocument}
                    type="application/pdf"
                  />
                </object>
              </div>
            </div>
          </div>
        );
      });
    }
    return carousel;
  }

  carouselIndicators(event) {
    var carouselIndicators;
    var that = this;
    if (this.state.PDFreviews) {
      const filteredPDFreviews = this.state.PDFreviews.sort(function (
        obj1,
        obj2
      ) {
        return obj1.Order - obj2.Order;
      });
      carouselIndicators = filteredPDFreviews.map((doc, key) => {
        let className = key === 0 ? "active" : "";
        return (
          <li
            onClick={() =>
              this.attachments(doc.docAttachments ?? [], doc.Guid, key)
            }
            data-target="#myCarousel_pdf"
            data-slide-to={key}
            className={className}
          ></li>
        );
      });
    }
    return carouselIndicators;
  }

  //========Handel chekbox=======
  handleCheckbox(e) {
    this.setState({
      [e.target.name]: e.target.checked,
    });

    if (e.target.checked) {
      $(".checkbox3_tbl").prop("checked", true);
    } else {
      $(".checkbox3_tbl").prop("checked", false);
    }
  }

  async sendAllSelectedDocs(e) {
    var _this = this;
    var selected = false;
    $(".checkbox3_tbl").each(function () {
      if (this.checked) {
        selected = true;
        _this.sendDocument(this.value);
      }
    });
    if (selected === false) {
      toast.error("Please select document to send.", {
        autoClose: 5000,
      });
    }
  }

  deleteDraft = async (guid) => {
    this.setState({ isLoading: true });
    await this.deleteDraftApi(guid)
      .then(async (data) => {
        if (data.status === true) {
          await this.getMultipleDocs(guid).then((response) => {
            if (!response.status) {
              this.setState({ isLoading: false });
              return false;
            }

            response.result.map((item) => {
              this.props
                .postRequest("/documents/delete-document-detail", {
                  Guid: item.Guid,
                })
                .then((res) => {
                  console.log("old doc deleted successfully.");

                  /*var uploadPath = item.TenantGuid+"/df-docs-pdf/"+item.Guid+".pdf";
              Storage.remove(uploadPath)
                  .then(result => console.log("file deleted"))
                  .catch(err => console.log(err));
                  console.log('deleting record');*/
                });
            });
          });

          $(".docdetail").hide();
          toast.success("Record has been deleted successfully.", {
            autoClose: 5000,
          });
        } else {
          toast.error("Record has not been deleted successfully.", {
            autoClose: 5000,
          });
        }
      })
      .catch((err) => {
        toast.error("Record has not been deleted successfully.", {
          autoClose: 5000,
        });
      });
    await this.allDigitalForm();
    this.setState({ isLoading: false });
  };

  //show more draft
  showMore = async (id, key) => {
    this.setState({
      documentsDescriptionLoading: true,
    });

    $(".docdetail").each(function () {
      if ($(this).attr("id") !== id + "aid") {
        $(this).hide();
      }
    });

    $(".arrowHandling").each(function () {
      if ($(this).attr("id") !== id + "arrowHandling") {
        $(this).css("transform", "");
      }
    });

    if ($("#" + id + "arrowHandling").css("transform") == "none") {
      $("#" + id + "arrowHandling").css("transform", "rotate(180deg)");
    } else {
      $("#" + id + "arrowHandling").css("transform", "");
    }

    $("#" + id + "aid").toggle();

    try {
      const response = await this.props.postRequest(
        "/documents/get-document-detail",
        { TanantGuid: id }
      );
      if (response.status) {
        var newArray = [];
        var newArray2 = [];
        this.setState({
          selectedDocDetails: response.result.sort(function (a, b) {
            return a.Order - b.Order;
          }),
          documentsDescriptionLoading: false,
        });
        this.updateCurrentForm(id);
      } else {
        toast.error(response.message, { autoClose: 5000 });
        this.setState({ documentsDescriptionLoading: false });
      }
      console.log("/documents/get-document-detail=>", response);
    } catch (err) {
      this.setState({ documentsDescriptionLoading: false });
      console.log("/documents/get-document-detail=>", err);
      toast.error(err.message, { autoClose: 5000 });
    }
  };

  //set current form
  setCurrentForm = async (type) => {
    //alert(type);
    this.setState({
      CurrentTab: type,
      CurrentForm: false,
      PDFreviews: false,
      sortBy: "",
      search: "",
    });
    //var digitalForms = this.state.digitalForms;

    if (type === "Approve") {
      var digitalForms = this.state.approverForms;
      if (digitalForms.length > 0) {
        await this.setState({ CurrentForm: digitalForms[0] });
        await this.setPDFPreviews(digitalForms[0].Guid);
      }
    } else if (type === "Pending") {
      var digitalForms = this.state.pendingForms;
      if (digitalForms.length > 0) {
        await this.setState({ CurrentForm: digitalForms[0] });
        await this.setPDFPreviews(digitalForms[0].Guid);
      }
    } else if (type === "Declined") {
      var digitalForms = this.state.declinedForms;
      if (digitalForms.length > 0) {
        await this.setState({ CurrentForm: digitalForms[0] });
        await this.setPDFPreviews(digitalForms[0].Guid);
      }
    } else if (type === "Approved") {
      var digitalForms = this.state.approvedForms;
      if (digitalForms.length > 0) {
        await this.setState({ CurrentForm: digitalForms[0] });
        await this.setPDFPreviews(digitalForms[0].Guid);
      }
    } else if (type === "All") {
      var digitalForms = this.state.allForms;
      if (digitalForms.length > 0) {
        await this.setState({ CurrentForm: digitalForms[0] });
        await this.setPDFPreviews(digitalForms[0].Guid);
      }
    }

    this.setState({ isLoading: false });

    //alert(type);
  };

  async getPdfMulti(PdfDocsData) {
    const options = {
      headers: {
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };
    var PdfPreviews = [];
    PdfDocsData.map((doc) => {
      //console.log('doc data=>', doc);
      axios
        .post(
          `${window.config.PDF_API_URL}${
            doc.digitalDoc.endsWith(".pdf") ? "/fill?py=1" : ""
          }`,
          doc,
          options
        )
        .then((res) => {
          console.log("pdf result ------=>", res);
          if (res.data.PDFDocument !== undefined) {
            PDFDocument = { status: true, data: res.data.PDFDocument };
            //console.log('axios result data=>',PDFDocument);
            PdfPreviews.push(PDFDocument);
            //return PDFDocument;
          } else {
            PDFDocument = { status: false, data: res.data.Reason };
            //console.log('axios result data=>',PDFDocument);
            PdfPreviews.push(PDFDocument);
            //return PDFDocument;
          }
        })
        .catch((error) => {
          PDFDocument = { status: false, data: error };
          //console.log('axios result data=>',PDFDocument);
          PdfPreviews.push(PDFDocument);
          //return PDFDocument;
        });
    });

    return PdfPreviews;
    //console.log('this.state.PdfPreviews=>', this.state.PdfPreviews);
  }

  async setPdfPreview(key) {
    const options = {
      headers: {
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };
    //console.log('doc data=>', PdfDocsData);
    this.setState({ showPreviewLoader: true });
    $(".pdfContainer").html("");
    if (this.state.PdfPreviews.length > 0) {
      var PdfDocsData = this.state.PdfPreviews[key];
      //console.log('PdfDocsData=>',PdfDocsData);

      if (!PdfDocsData.Confidential) {
        axios
          .post(
            `${window.config.PDF_API_URL}${
              PdfDocsData.digitalDoc.endsWith(".pdf") ? "/fill?py=1" : ""
            }`,
            PdfDocsData,
            options
          )
          .then((res) => {
            if (res.data.PDFDocument !== undefined) {
              PDFDocument =
                "data:application/pdf;base64," + res.data.PDFDocument;
              $(".pdfContainer").html(
                '<object data="' +
                  PDFDocument +
                  '" type="application/pdf" style="width:100%; min-height:calc(100vh - 200px)"><embed src="' +
                  PDFDocument +
                  '" type="application/pdf" /></object>'
              );
            } else {
              $(".pdfContainer").html("<p>" + res.data.Reason + "</p>");
            }
            this.setState({ showPreviewLoader: false });
            //console.log('axios result data=>',res.data);
          })
          .catch((error) => {
            $(".pdfContainer").html("<p>" + error + "</p>");
            //console.log('axios result error=>',error);
            this.setState({ showPreviewLoader: false });
          });
      } else {
        this.setState({ showPreviewLoader: false });
        $(".pdfContainer").html('<p style="color:red;">Confidential</p>');
      }
    }
  }

  async setSignaturs() {
    var that = this;

    if (this.state.CurrentForm) {
      var formData = this.state.CurrentForm;
      var signatures = {};
      //console.log("Pre Signature=>", this.state.Signatures);
      if (formData.ApprovalChain.length > 0) {
        formData.ApprovalChain.map(function (approver, index) {
          //console.log("approver "+index+"=>", approver);
          if (approver.Signed) {
            signatures[
              that.state.TempFilePath +
                "/AppBlank" +
                approver.SigPosition +
                ".jpg"
            ] = approver.signPath ?? "";
            signatures["AppIP" + approver.SigPosition] = approver.AppIP
              ? approver.AppIP
              : "";
            signatures["AppTimestamp" + approver.SigPosition] =
              approver.AppTimeStamp ? approver.AppTimeStamp : "";
          }
        });
      }

      if (formData.ExtSigners.length > 0) {
        formData.ExtSigners.map(function (signer, index) {
          //console.log("signer "+index+"=>", signer);
          if (signer.Signed) {
            signatures[
              that.state.TempFilePath +
                "/ExtBlank" +
                signer.SigPosition +
                ".jpg"
            ] = signer.signPath ?? "";
            signatures["ExtIP" + signer.SigPosition] = signer.ExtIP
              ? signer.ExtIP
              : "";
            signatures["ExtTimestamp" + signer.SigPosition] =
              signer.ExtTimeStamp ? signer.ExtTimeStamp : "";
          }
        });
      }
      this.setState({ Signatures: signatures });
    }
  }

  async setPDFPreviews(Guid) {
    // console.log("CurrentForm=>", this.state.CurrentForm);
    await this.setSignaturs();
    // console.log("setPDFPreviews Guid=>", Guid);
    this.setState({ selectedDFDocs: [] });
    if (Guid) {
      //console.log('Form data in did mount: ', Guid);
      await this.getMultipleDocs(Guid)
        .then((response) => {
          if (!response.status) {
            this.setState({ isLoading: false });
            toast.error(response.error, { autoClose: 5000 });
            return false;
          }
          this.setState({ selectedDFDocs: response.result });
          var PdfDocsData = [];

          response.result.map((doc) => {
            var Document =
              doc.CompanyGuid + "/" + doc.TenantGuid + "/" + doc.DigitalDoc;
            var DocDetails = doc.DocDetails;
            var CustomList = doc.CustomList;

            var jsObj = {};
            const signatureCoordinates = {};
            if (DocDetails) {
              DocDetails.map((detail) => {
                if (detail.Tag) {
                  if (detail.Type === "Date") {
                    jsObj[detail.Tag] = detail.DefaultValue
                      ? moment(new Date(detail.DefaultValue)).format(
                          "DD/MM/YYYY"
                        )
                      : "";
                  } else {
                    jsObj[detail.Tag] = detail.DefaultValue
                      ? detail.DefaultValue
                      : "";
                  }

                  if (
                    detail.Tag?.includes("AppBlank") ||
                    detail.Tag?.includes("ExtBlank")
                  ) {
                    signatureCoordinates[`/coordinates/${detail.Tag}`] =
                      detail.DefaultValue;
                  }
                }
              });
            }

            if (CustomList && CustomList.length > 0) {
              CustomList.map((list) => {
                //jsObj[detail.Tag] = detail.DefaultValue? detail.DefaultValue : "";
                list.CustomFields.map((field) => {
                  if (field.Tag) {
                    if (
                      field.Prompt === "startDate" ||
                      field.Prompt === "endDate"
                    ) {
                      jsObj[field.Tag] = field.DefaultValue
                        ? moment(new Date(field.DefaultValue)).format(
                            "DD/MM/YYYY"
                          )
                        : "";
                    } else {
                      jsObj[field.Tag] = field.DefaultValue
                        ? field.DefaultValue
                        : "";
                    }
                  }
                });
              });
            }

            // var pdfData = {
            //   Document: window.config.S3_BUCKET + "/" + Document,
            //   ApiKey: window.config.PDF_API_KEY,
            //   Confidential: doc.Confidential,
            //   tags: jsObj,
            //   Signatures: this.state.Signatures,
            //   test: "adasdasd",
            //   tenantGuid:"",
            //   companyGuid:""
            // };
            var pdfData = {
              ApiKey: window.config.PDF_API_KEY,
              Confidential: doc.Confidential,
              tags: jsObj,
              signatures: { ...this.state.Signatures, ...signatureCoordinates },
              tenantGuid: localStorage.getItem("currentTenantGuid"),
              companyGuid: localStorage.getItem("companyGuid"),
              digitalDoc: doc.DigitalDoc.split("/").pop(),
              filename: doc.filename,
              docAttachments: doc.DocumentAtt,
            };

            //this.getPdf(pdfData);

            PdfDocsData.push(pdfData);
            //console.log('doc detail obj=>',jsObj);
          });

          // console.log("PdfDocsData => ", PdfDocsData);
          this.setState({ PdfPreviews: PdfDocsData });
          this.setPdfPreview(0);
          //console.log('first form data => ', data);
          /*this.getPdfMulti(PdfDocsData).then(data =>{
            console.log('PdfPreviews returned => ', data);
            //this.setState({ PdfPreviews:data, isLoading:false });
        })*/
          //this.getPdf(PdfDocsData[0]);

          // this.setState({ PDFreviews: response.result, isLoading: false });
          this.setState({ PDFreviews: PdfDocsData, isLoading: false });
          var list = [];
          if (response.result[0]) {
            this.setState({
              doc_count: PdfDocsData.length,
              docAttachmentsCount: PdfDocsData[0]?.docAttachments.length,
              docAttachments: PdfDocsData[0]?.docAttachments,
              doc_list: response.result[0]?.DocumentAtt,
              doc_external_list: response.result[0]?.DocDetails
                ? response.result[0].DocDetails.filter(
                    (doc) =>
                      doc.Type === "File" &&
                      doc.DefaultValue?.includes("formTemplate-documents/")
                  ).map((doc) => doc.DefaultValue)
                : [],
              doc_Guid: response.result[0]?.Guid,
            });
          }
        })
        .catch((err) => {
          this.setState({ PDFreviews: false, isLoading: false });
          console.error("error in get multi docs: ", err);
        });
    } else {
      this.setState({ PDFreviews: false, isLoading: false });
    }
  }

  headerNav(e) {
    $(".checkbox3_tbl").prop("checked", false);
    this.setState({ checkbox3_tbl: false });
    if (e.target.id === "tab_default_document_Pending") {
      $("#default_document_Pending").show();
      $("#default_document_Approve").hide();
      $("#default_document_Approved").hide();
      $("#default_document_Declined").hide();
      $("#default_document_All").hide();
      $("#default_document_draft").hide();
      this.setCurrentForm("Pending");
      let data = [...this.state.pendingForms];
      let newArra = [];
      data.map((items) => {
        if (items.Status === "Pending") {
          newArra.push(items);
        }
      });
      this.setState({
        currentTabDigitalFormData: newArra,
      });
    }

    if (e.target.id === "tab_default_document_Approve") {
      $("#default_document_Pending").hide();
      $("#default_document_Approve").show();
      $("#default_document_Approved").hide();
      $("#default_document_Declined").hide();
      $("#default_document_All").hide();
      $("#default_document_draft").hide();
      this.setCurrentForm("Approve");
      let data = [...this.state.approverForms];
      let newArra = [];
      data.map((items) => {
        if (items.Status === "Pending") {
          newArra.push(items);
        }
      });
      this.setState({
        currentTabDigitalFormData: newArra,
      });
    } else if (e.target.id === "tab_default_document_Approved") {
      $("#default_document_Pending").hide();
      $("#default_document_Approve").hide();
      $("#default_document_Approved").show();
      $("#default_document_Declined").hide();
      $("#default_document_All").hide();
      $("#default_document_draft").hide();
      this.setCurrentForm("Approved");
      let data = [...this.state.approvedForms];
      let newArra = [];
      data.map((items) => {
        if (items.Status === "Approved") {
          newArra.push(items);
        }
      });
      this.setState({
        currentTabDigitalFormData: newArra,
      });
    } else if (e.target.id === "tab_default_document_Declined") {
      $("#default_document_Approve").hide();
      $("#default_document_Approved").hide();
      $("#default_document_Declined").show();
      $("#default_document_All").hide();
      $("#default_document_draft").hide();
      $("#default_document_Pending").hide();
      this.setCurrentForm("Declined");
      let data = [...this.state.declinedForms];
      let newArra = [];
      data.map((items) => {
        if (items.Status === "Declined") {
          newArra.push(items);
        }
      });
      this.setState({
        currentTabDigitalFormData: newArra,
      });
    } else if (e.target.id === "tab_default_document_All") {
      $("#default_document_Approve").hide();
      $("#default_document_Pending").hide();
      $("#default_document_Approved").hide();
      $("#default_document_Declined").hide();
      $("#default_document_All").show();
      $("#default_document_draft").hide();
      this.setCurrentForm("All");
      let data = [...this.state.allForms];
      let newArra = [];
      data.map((items) => {
        newArra.push(items);
      });
      this.setState({
        currentTabDigitalFormData: newArra,
      });
    } else if (e.target.id === "tab_default_document_draft") {
      $("#default_document_Approve").hide();
      $("#default_document_Pending").hide();
      $("#default_document_Approved").hide();
      $("#default_document_Declined").hide();
      $("#default_document_All").hide();
      $("#default_document_draft").show();
      this.setCurrentForm("Draft");
    }
  }
  change_record = async (eve) => {
    console.log(
      "this.state.currentTabDigitalFormData",
      this.state.currentTabDigitalFormData
    );
    console.log("this.state.CurrentForm", this.state.CurrentForm);
    if (eve === "next") {
      var index = this.state.currentTabDigitalFormData.findIndex(
        (x) => x.Guid === this.state.CurrentForm.Guid
      );
      if (index < this.state.currentTabDigitalFormData.length - 1) {
        await this.updateCurrentForm(
          this.state.currentTabDigitalFormData[index + 1].Guid
        );
      }
    } else {
      var index = this.state.currentTabDigitalFormData.findIndex(
        (x) => x.Guid === this.state.CurrentForm.Guid
      );

      if (index > 0) {
        await this.updateCurrentForm(
          this.state.currentTabDigitalFormData[index - 1].Guid
        );
      }
    }
  };

  renderCurrentForm() {
    if (this.state.CurrentTab === "Approve") {
      var isCurrentApprover = this.isCurrentApprover(
        this.state.CurrentForm.CurrentApproval
      );

      return (
        <div>
          <div className="slider_grid_layout">
            <div className="slider_grid">
              <div className="slider_grid_inner">
                {isCurrentApprover ? (
                  <div className="decline">
                    <a href="" onClick={(event) => this.approveForm(event)}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 19.122 14.559"
                      >
                        <path
                          id="ic_done_24px"
                          className="cls-1"
                          d="M9.484,17.117,4.921,12.553,3.4,14.074l6.084,6.084L22.522,7.121,21,5.6Z"
                          transform="translate(-3.4 -5.6)"
                        />
                      </svg>
                      <span> Approve</span>
                    </a>
                  </div>
                ) : (
                  ""
                )}
                {isCurrentApprover ? (
                  <div className="decline">
                    <a
                      href=""
                      onClick={(event) => this.declineModalOpen(event)}
                      data-toggle="modal"
                      data-target="#myModal_decline_digi_form"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path
                          id="ic_not_interested_24px"
                          className="cls-1"
                          d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,0,1-8-8A7.9,7.9,0,0,1,5.69,7.1L16.9,18.31A7.9,7.9,0,0,1,12,20Zm6.31-3.1L7.1,5.69A7.9,7.9,0,0,1,12,4a8,8,0,0,1,8,8A7.9,7.9,0,0,1,18.31,16.9Z"
                          transform="translate(-2 -2)"
                        />
                      </svg>
                      <span> Decline</span>
                    </a>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>

            <div className="slider_grid">
              <div className="text-center file_viewer">
                <button
                  type="button"
                  className="btn btn-sm"
                  data-toggle="modal"
                  data-target="#myModal_comment_digi_form"
                >
                  <img src={message} alt="" />
                  <span className="badge_custom">
                    {this.state.CurrentForm.Comments.length}
                  </span>
                </button>
              </div>
            </div>

            <div className="slider_grid">
              <div className="page_prev_next">
                <a
                  className="left cursorPointer"
                  onClick={this.change_record.bind(this, "back")}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 10 16.194"
                  >
                    <path
                      id="ic_chevron_left_24px"
                      className="cls-1"
                      d="M18,7.9,16.1,6,8,14.1l8.1,8.1,1.9-1.9L11.819,14.1Z"
                      transform="translate(-8 -6)"
                    />
                  </svg>
                  <span> Back</span>
                </a>
                |
                <a
                  className="message_svg right cursorPointer"
                  onClick={this.change_record.bind(this, "next")}
                >
                  <span> Next</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 10 16.19"
                  >
                    <path
                      id="ic_chevron_right_24px"
                      className="cls-1"
                      d="M10.493,6,8.59,7.9l6.181,6.193L8.59,20.288l1.9,1.9,8.1-8.1Z"
                      transform="translate(-8.59 -6)"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div>

          <div className="col-sm-12">
            <div className="slider_pdf_viewer">
              <div
                id="myCarousel_pdf"
                className="carousel slide"
                data-ride="carousel"
              >
                <ol className="carousel-indicators">
                  {this.carouselIndicators()}
                </ol>
                <div className="carousel-inner">{this.carouselInner()}</div>
              </div>
              <div className="clearfix"></div>
            </div>
            <div className="clearfix"></div>
          </div>
          <div className="clearfix"></div>
        </div>
      );
    } else if (this.state.CurrentTab === "Pending") {
      return (
        <div>
          <div className="slider_grid_layout">
            <div className="slider_grid">
              <div className="slider_grid_inner">
                <div className="decline">
                  {this.state.CurrentForm.EmpGuid ===
                  localStorage.getItem("Guid") ? (
                    <a href="" onClick={(event) => this.moveFormToDraft(event)}>
                      <span> Move</span>
                    </a>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>

            <div className="slider_grid">
              <div className="text-center file_viewer">
                <button
                  type="button"
                  className="btn btn-sm"
                  data-toggle="modal"
                  data-target="#myModal_comment_digi_form"
                >
                  <img src={message} alt="" />
                  <span className="badge_custom">
                    {this.state.CurrentForm.Comments.length}
                  </span>
                </button>
              </div>
            </div>

            <div className="slider_grid">
              <div className="page_prev_next">
                <a
                  className="left cursorPointer"
                  onClick={this.change_record.bind(this, "back")}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 10 16.194"
                  >
                    <path
                      id="ic_chevron_left_24px"
                      className="cls-1"
                      d="M18,7.9,16.1,6,8,14.1l8.1,8.1,1.9-1.9L11.819,14.1Z"
                      transform="translate(-8 -6)"
                    />
                  </svg>
                  <span> Back</span>
                </a>
                |
                <a
                  className="message_svg right cursorPointer"
                  onClick={this.change_record.bind(this, "next")}
                >
                  <span> Next</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 10 16.19"
                  >
                    <path
                      id="ic_chevron_right_24px"
                      className="cls-1"
                      d="M10.493,6,8.59,7.9l6.181,6.193L8.59,20.288l1.9,1.9,8.1-8.1Z"
                      transform="translate(-8.59 -6)"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div>

          <div className="col-sm-12">
            <div className="slider_pdf_viewer">
              <div
                id="myCarousel_pdf"
                className="carousel slide"
                data-ride="carousel"
              >
                <ol className="carousel-indicators">
                  {this.carouselIndicators()}
                </ol>
                <div className="carousel-inner">{this.carouselInner()}</div>
              </div>
            </div>
          </div>
        </div>
      );
    } else if (this.state.CurrentTab === "Declined") {
      return (
        <div>
          <div className="slider_grid_layout">
            <div className="slider_grid">
              <div className="slider_grid_inner">
                <div className="decline">
                  {this.state.CurrentForm.EmpGuid ===
                  localStorage.getItem("Guid") ? (
                    <a href="" onClick={(event) => this.moveFormToDraft(event)}>
                      <span> Move</span>
                    </a>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>

            <div className="slider_grid">
              <div className="text-center file_viewer">
                <button
                  type="button"
                  className="btn btn-sm"
                  data-toggle="modal"
                  data-target="#myModal_comment_digi_form"
                >
                  <img src={message} alt="" />
                  <span className="badge_custom">
                    {this.state.CurrentForm.Comments.length}
                  </span>
                </button>
              </div>
            </div>

            <div className="slider_grid">
              <div className="page_prev_next">
                <a
                  className="left cursorPointer"
                  onClick={this.change_record.bind(this, "back")}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 10 16.194"
                  >
                    <path
                      id="ic_chevron_left_24px"
                      className="cls-1"
                      d="M18,7.9,16.1,6,8,14.1l8.1,8.1,1.9-1.9L11.819,14.1Z"
                      transform="translate(-8 -6)"
                    />
                  </svg>
                  <span> Back</span>
                </a>
                |
                <a
                  className="message_svg right cursorPointer"
                  onClick={this.change_record.bind(this, "next")}
                >
                  <span> Next</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 10 16.19"
                  >
                    <path
                      id="ic_chevron_right_24px"
                      className="cls-1"
                      d="M10.493,6,8.59,7.9l6.181,6.193L8.59,20.288l1.9,1.9,8.1-8.1Z"
                      transform="translate(-8.59 -6)"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div>

          <div className="col-sm-12">
            <div className="slider_pdf_viewer">
              <div
                id="myCarousel_pdf"
                className="carousel slide"
                data-ride="carousel"
              >
                <ol className="carousel-indicators">
                  {this.carouselIndicators()}
                </ol>
                <div className="carousel-inner">{this.carouselInner()}</div>
              </div>
            </div>
          </div>
        </div>
      );
    } else if (this.state.CurrentTab === "Approved") {
      return (
        <div>
          <div className="slider_grid_layout">
            <div className="slider_grid">
              <div className="slider_grid_inner">
                <div className="approve_tick">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 19.122 14.559"
                  >
                    <path
                      id="ic_done_24px"
                      className="cls-1"
                      d="M9.484,17.117,4.921,12.553,3.4,14.074l6.084,6.084L22.522,7.121,21,5.6Z"
                      transform="translate(-3.4 -5.6)"
                    />
                  </svg>
                  <span> Approved</span>
                </div>
              </div>
            </div>

            <div className="slider_grid">
              <div className="text-center file_viewer">
                <button
                  type="button"
                  className="btn btn-sm"
                  data-toggle="modal"
                  data-target="#myModal_comment_digi_form"
                >
                  <img src={message} alt="" />
                  <span className="badge_custom">
                    {this.state.CurrentForm.Comments.length}
                  </span>
                </button>
              </div>
            </div>

            <div className="slider_grid">
              <div className="page_prev_next">
                <a
                  className="left cursorPointer"
                  onClick={this.change_record.bind(this, "back")}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 10 16.194"
                  >
                    <path
                      id="ic_chevron_left_24px"
                      className="cls-1"
                      d="M18,7.9,16.1,6,8,14.1l8.1,8.1,1.9-1.9L11.819,14.1Z"
                      transform="translate(-8 -6)"
                    />
                  </svg>
                  <span> Back</span>
                </a>
                |
                <a
                  className="message_svg right cursorPointer"
                  onClick={this.change_record.bind(this, "next")}
                >
                  <span> Next</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 10 16.19"
                  >
                    <path
                      id="ic_chevron_right_24px"
                      className="cls-1"
                      d="M10.493,6,8.59,7.9l6.181,6.193L8.59,20.288l1.9,1.9,8.1-8.1Z"
                      transform="translate(-8.59 -6)"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div>

          <div className="col-sm-12">
            <div className="slider_pdf_viewer">
              <div
                id="myCarousel_pdf"
                className="carousel slide"
                data-ride="carousel"
              >
                <ol className="carousel-indicators">
                  {this.carouselIndicators()}
                </ol>
                <div className="carousel-inner">{this.carouselInner()}</div>
              </div>
            </div>
          </div>
        </div>
      );
    } else if (this.state.CurrentTab === "All") {
      return (
        <div>
          <div className="slider_grid_layout">
            <div className="slider_grid">
              <div className="slider_grid_inner">
                {this.state.CurrentForm.Status === "Approved" ? (
                  <div className="approve_tick">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 19.122 14.559"
                    >
                      <path
                        id="ic_done_24px"
                        className="cls-1"
                        d="M9.484,17.117,4.921,12.553,3.4,14.074l6.084,6.084L22.522,7.121,21,5.6Z"
                        transform="translate(-3.4 -5.6)"
                      />
                    </svg>
                    <span> Approved</span>
                  </div>
                ) : (
                  <div className="decline">
                    <span>{this.state.CurrentForm.Status}</span>
                  </div>
                )}
              </div>
            </div>

            <div className="slider_grid">
              <div className="text-center file_viewer">
                <button
                  type="button"
                  className="btn btn-sm"
                  data-toggle="modal"
                  data-target="#myModal_comment_digi_form"
                >
                  <img src={message} alt="" />
                  <span className="badge_custom">
                    {this.state.CurrentForm.Comments.length}
                  </span>
                </button>
              </div>
            </div>

            <div className="slider_grid">
              <div className="page_prev_next">
                <a
                  className="left cursorPointer"
                  onClick={this.change_record.bind(this, "back")}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 10 16.194"
                  >
                    <path
                      id="ic_chevron_left_24px"
                      className="cls-1"
                      d="M18,7.9,16.1,6,8,14.1l8.1,8.1,1.9-1.9L11.819,14.1Z"
                      transform="translate(-8 -6)"
                    />
                  </svg>
                  <span> Back</span>
                </a>
                |
                <a
                  className="message_svg right cursorPointer"
                  onClick={this.change_record.bind(this, "next")}
                >
                  <span> Next</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 10 16.19"
                  >
                    <path
                      id="ic_chevron_right_24px"
                      className="cls-1"
                      d="M10.493,6,8.59,7.9l6.181,6.193L8.59,20.288l1.9,1.9,8.1-8.1Z"
                      transform="translate(-8.59 -6)"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div>

          <div className="col-sm-12">
            <div className="slider_pdf_viewer">
              <div
                id="myCarousel_pdf"
                className="carousel slide"
                data-ride="carousel"
              >
                <ol className="carousel-indicators">
                  {this.carouselIndicators()}
                </ol>
                <div className="carousel-inner">{this.carouselInner()}</div>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return "";
    }
  }
  addComment = async () => {
    var objectpush = {
      Comment: this.state.comment_add,
      DateTime: moment(new Date()).format("DD/MM/YYYY hh:ss"),
      Name: localStorage.getItem("userName"),
    };
    this.state.CurrentForm.Comments.push(objectpush);
    await this.setState({
      CurrentForm: this.state.CurrentForm,
    });
    await API.post("updatedocument", "/updatedocument", {
      body: {
        Guid: this.state.CurrentForm.guid,
        updatecomment: "yes",
        Comments: this.state.CurrentForm.Comments,
      },
    })
      .then((data) => {
        document.getElementById("Close_comment").click();
        toast.success("Comment added successfully");
      })
      .catch((error) => {
        toast.error(error.message);
      });
    await this.setState({
      comment_add: "",
    });
  };

  attachments = (docs, Guid, key) => {
    this.setState({
      doc_count: docs.length,
      docAttachmentsCount: docs.length,
      docAttachments: docs,
      doc_list: docs,
      doc_Guid: Guid,
    });

    this.setPdfPreview(key);
  };

  showfile = async (url) => {
    var thisobj = this;

    Storage.get(url)
      .then((result) => {
        if (result !== "") {
          window.open(result, "_blank");
        }
      })
      .catch((err) => console.log(err));
  };
  onDrop = async (files) => {
    await this.setState({
      isLoading: true,
    });

    var tmp_doc_list = this.state.doc_list;
    await files.forEach((file) => {
      var file_name =
        localStorage.getItem("useableGuid") +
        "/formTemplate-documents/" +
        new Date().getTime() +
        "-" +
        file.name;
      Storage.put(file_name, file, { contentType: file.type })
        .then((result) => {
          var uploadedObj = {
            ContentType: "UTF-8",
            DocDesc: "Timecard document",
            DoumentType: file.type,
            Encrypted: "No",
            filename: file.name,
            PWHash: "a7e7ef%^%*&(7ke834",
            Salt: "HFHHGVHJBJB",
            Timestamp: new Date().getTime(),
            url: result.key,
          };
          tmp_doc_list.push(uploadedObj);
          this.updateAttachments(tmp_doc_list);
        })
        .catch((err) => console.log(err));
    });

    this.setState({
      isLoading: false,
    });
  };
  async updateAttachments(DocumentAtt) {
    if (this.state.doc_Guid) {
      await this.setState({
        doc_count: DocumentAtt.length,
        doc_list: DocumentAtt,
      });
      return API.post("dfdocsupdateatt", "/dfdocsupdateatt", {
        body: {
          DocumentAtt: DocumentAtt,
          Guid: this.state.doc_Guid,
        },
      });
    }
  }

  onChangeHandler = async (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  onPaste = async () => {
    const pastedExcelData = this.state.excelImportData;
    var rows = [];
    var FormPack = null;
    var FirstName = null;
    var LastName = null;
    var Email = null;
    var Mobile = null;
    var ApprovalGroup = null;
    var CustomFields = [];
    var DocIndex = -1;
    var DFDocs = [];

    var res1 = pastedExcelData.split("\n");

    for (var i = 0; i < res1.length; i++) {
      //console.log('row'+i+' data=>',res1[i].split("\t"));
      rows.push(res1[i].split("\t"));
    }

    if (rows[0].length === 10) {
      FormPack = rows[1][0];
      FirstName = rows[2][3];
      LastName = rows[3][3];
      Email = rows[2][7];
      Mobile = rows[3][7];
      ApprovalGroup = rows[4][7];
    } else {
      FormPack = rows[1][0];
      FirstName = rows[2][3];
      LastName = rows[3][3];
      Email = rows[2][11];
      Mobile = rows[3][11];
      ApprovalGroup = rows[4][11];
    }

    if (FormPack === "" || FormPack === null || FormPack === undefined) {
      toast.error("Please enter Form pack");
      return false;
    }

    var packCode = rows[0][0];
    if (packCode === "" || packCode === null || packCode === undefined) {
      toast.error("Please enter Formpack code", { autoClose: 5000 });
      return false;
    }

    if (FirstName === "" || FirstName === null || FirstName === undefined) {
      toast.error("Please enter First Name", { autoClose: 5000 });
      return false;
    }

    if (LastName === "" || LastName === null || LastName === undefined) {
      toast.error("Please enter Last Name", { autoClose: 5000 });
      return false;
    }

    if (Email === "" || Email === null || Email === undefined) {
      toast.error("Please enter Email address", { autoClose: 5000 });
      return false;
    }

    if (
      !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        Email
      )
    ) {
      toast.error("Please enter Valid Email address", { autoClose: 5000 });
      return false;
    }

    if (Mobile === "" || Mobile === null || Mobile === undefined) {
      toast.error("Please enter Mobile Number", { autoClose: 5000 });
      return false;
    }

    if (
      ApprovalGroup === "" ||
      ApprovalGroup === null ||
      ApprovalGroup === undefined
    ) {
      toast.error("Please enter Approval Group", { autoClose: 5000 });
      return false;
    }
    var formpackGuid = null;
    var Documents = [];
    var ProjectGuid = null;
    this.setState({ isLoading: true });
    try {
      const pack_response = await this.props.postRequest(
        "/form-pack/get-pack-by-code",
        { Code: packCode, CompanyGuid: localStorage.getItem("companyGuid") }
      );
      if (pack_response.status) {
        formpackGuid = pack_response.result.Guid;
        Documents = pack_response.result.Documents;
        ProjectGuid = pack_response.result.ProjectGuid;
      } else {
        console.log("pack_response=>", pack_response);
      }
    } catch (err) {
      console.log("onPast pack_response Error=>", err);
    }

    var approverGroupID = null;
    var ApprovalChain = [];
    try {
      const app_group_response = await this.props.postRequest(
        "/approval-setup/get-approver-group-by-name",
        {
          ApprovalGroup: ApprovalGroup,
          CompanyGuid: localStorage.getItem("companyGuid"),
        }
      );
      if (app_group_response.status) {
        ApprovalChain = app_group_response.ApprovalChain;
        approverGroupID = app_group_response.approverGroupID;
      } else {
        console.log("app_group_response=>", app_group_response);
      }
    } catch (err) {
      console.log("onPast app_group_response Error=>", err);
    }

    if (
      formpackGuid === "" ||
      formpackGuid === null ||
      formpackGuid === undefined
    ) {
      toast.error("Please enter Valid Form Pack Code to proceed");
      this.setState({ isLoading: false });
      return false;
    }

    if (
      approverGroupID === "" ||
      approverGroupID === null ||
      approverGroupID === undefined
    ) {
      toast.error("Please enter Valid Approval Group to proceed", {
        autoClose: 5000,
      });
      this.setState({ isLoading: false });
      return false;
    }
    var DocDetailsIndex = 0;
    if (rows[5][0] === "DOCUMENTS") {
      for (var i = 8; i < rows.length; i++) {
        if (rows[i][0] === "Template Code") {
          i += 2;
        }

        if (rows[i][0] === "DETAIL FIELDS") {
          DocIndex++;
          DocDetailsIndex = 0;
          i++;
        }
        i = rows[i][0].includes("#") ? i + 1 : i;

        if (
          (rows[i][1] !== null ||
            rows[i][1] !== undefined ||
            rows[i][1] !== "") &&
          DocDetailsIndex < Documents[DocIndex].DocDetails.length
        ) {
          Documents[DocIndex].DocDetails[DocDetailsIndex].DefaultValue =
            rows[i][4];
          Documents[DocIndex].DocDetails[DocDetailsIndex].Value = rows[i][4];
          DocDetailsIndex++;
        }
      }
    }

    const formTemplateData = {};
    var ExtSigners = [
      {
        countryCode: null,
        Email: Email,
        FirstName: FirstName,
        Lastname: LastName,
        Mobile: Mobile,
        Sequence: "1",
        SigPosition: "1",
      },
    ];
    formTemplateData.Activity = [
      {
        Description: "Created new Digital Form. " + FormPack + " Pack selected",
        IPAddress: this.state.ipv4,
        Timestamp: moment().unix(),
        Type: "NEWDigitalForm",
        User: localStorage.getItem("userName"),
        profile_pic_url: localStorage.getItem("profile_pic_url"),
      },
    ];
    formTemplateData.ApprovalChain = ApprovalChain;
    formTemplateData.ApprovalGroupguid = approverGroupID;
    formTemplateData.ApprovalGroup = ApprovalGroup;
    formTemplateData.CreatedTS = moment().unix();
    formTemplateData.CustomFields = CustomFields;
    formTemplateData.Documents = Documents;
    formTemplateData.Email = Email;
    formTemplateData.EmpGuid = localStorage.getItem("Guid");
    formTemplateData.ExtSigners = ExtSigners;
    formTemplateData.FormpackGuid = formpackGuid;
    formTemplateData.FirstName = FirstName;
    formTemplateData.LastName = LastName;
    formTemplateData.FormPack = FormPack;
    formTemplateData.CountryCode = null;
    formTemplateData.Mobile = Mobile;
    formTemplateData.TenantGuid = localStorage.getItem("currentTenantGuid");
    formTemplateData.Timestamp = moment();
    formTemplateData.ProjectGuid = ProjectGuid;
    formTemplateData.UserName = localStorage.getItem("userName");
    formTemplateData.CompanyID = localStorage.getItem("companyID");
    formTemplateData.CompanyGuid = localStorage.getItem("companyGuid");
    //console.log('formTemplateData=>', formTemplateData);
    try {
      const create_response = await this.props.postRequest(
        "/documents/create-document",
        formTemplateData
      );
      if (create_response.status) {
        const createDFDocs = await this.props.postRequest(
          "/documents/create-document-detail",
          { form: Documents, TanantGuid: create_response.result.Guid }
        );
        if (createDFDocs.status) {
          this.allDigitalForm();
          this.setState({ isLoading: false });
        } else {
          this.setState({ isLoading: false });
          toast.error(createDFDocs.error, { autoClose: 5000 });
          console.log(
            "onPast /documents/create-document-detail=>",
            createDFDocs
          );
        }
      } else {
        toast.error(create_response.error, { autoClose: 5000 });
        this.setState({ isLoading: false });
        console.log("onPast /documents/create-document=>", create_response);
      }
    } catch (err) {
      this.setState({ isLoading: false });
      toast.error(err.message, { autoClose: 5000 });
      console.log("onPast Error=>", err);
    }
  };

  selectedDocumentToshowActivities = (key) => {
    this.setState({
      selectedDocumentForReadAllActivities: this.state.draftForms[key],
    });
  };

  loadDocument = async (url) => {
    await Storage.get(url).then((data) => {
      this.setState({
        documentUrl: data,
      });
    });
  };

  onShowDocument = async (url) => {
    console.log("Document URL => ", url);
    const response = await this.props.postRequest("/attachments/fetch", {
      upload_path: url,
      CompanyGuid: localStorage.getItem("companyGuid"),
      TenantGuid: localStorage.getItem("currentTenantGuid"),
    });
    console.log("response", response);
    window.open(response.attachment);
  };

  previewAttachment = async (url) => {
    try {
      this.setState({ isLoading: true });
      const response = await this.props.postRequest("/attachments/fetch", {
        upload_path: url,
        CompanyGuid: localStorage.getItem("companyGuid"),
        TenantGuid: localStorage.getItem("currentTenantGuid"),
      });
      window.open(response.attachment);
    } catch (error) {
      toast.error("Failed to fetch the attachment preview");
    } finally {
      this.setState({ isLoading: false });
    }
  };

  showDocumentPdf = async (doc, key) => {
    this.setState({ isLoading: true });
    /*    var Document = doc.DigitalDoc;
        var DocDetails = doc.DocDetails;
        var CustomList = doc.CustomList;

        var jsObj = {};
        DocDetails.map(detail => {
          jsObj[detail.Tag] = detail.DefaultValue? detail.DefaultValue : "";
        });

        if(CustomList.length > 0){

          CustomList.map(list => {
            //jsObj[detail.Tag] = detail.DefaultValue? detail.DefaultValue : "";
            list.CustomFields.map(field => {
              if(field.Tag){
                jsObj[field.Tag] = field.DefaultValue? field.DefaultValue : "";
              }
            });

          });
        }

        var pdfData = {
              "Document": window.config.S3_BUCKET+'/public/'+Document,
              "ApiKey": window.config.PDF_API_KEY,
              "Data": jsObj,
              "Signatures": {
              "BucketName/Path_To_Default_Signature/Extblank1.jpg": "BucketName/Path_To_User_Signatures/Users_Signature.jpg",
              "BucketName/Path_To_Default_Signature/blank1.jpg": "BucketName/Path_To_User_Signatures/User_Signature.jpg"
            }
        };

        console.log('pdfData =>', pdfData);*/
    console.log("doc", doc, this.state.PdfPreviews);
    const options = {
      headers: {
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };

    var PdfDocsData = this.state.PdfPreviews?.filter(
      (item) => item.digitalDoc == doc.DigitalDoc?.split("/").pop()
    );

    const signatureCoordinates = {};
    if (doc.DocDetails) {
      doc.DocDetails.forEach((detail) => {
        if (
          detail.Tag?.includes("AppBlank") ||
          detail.Tag?.includes("ExtBlank")
        ) {
          signatureCoordinates[`/coordinates/${detail.Tag}`] =
            detail.DefaultValue;
        }
      });
    }

    if (!PdfDocsData[0]) {
      PdfDocsData = [
        {
          tags: {},
          signatures: { ...this.state.Signatures, ...signatureCoordinates },
          tenantGuid: localStorage.getItem("currentTenantGuid"),
          companyGuid: localStorage.getItem("companyGuid"),
          digitalDoc: doc.DigitalDoc.split("/").pop(),
        },
      ];
    }

    axios
      .post(
        `${window.config.PDF_API_URL}${
          PdfDocsData[0]?.digitalDoc.endsWith(".pdf") ? "/fill?py=1" : ""
        }`,
        PdfDocsData.length ? PdfDocsData[0] : {},
        options
      )
      .then((res) => {
        var pdfWindow = window.open();
        pdfWindow.document
          .open()
          .write(
            "<html><head><title>Preview</title></head><body style='margin:0; text-align: center;'><h1 class='previewLoading'>Loading.....</h1></body></html>"
          );

        if (res.data.PDFDocument !== undefined) {
          PDFDocument = "data:application/pdf;base64," + res.data.PDFDocument;
          //console.log("PDFDocument =>",PDFDocument);
          pdfWindow.document
            .open()
            .write(
              "<html><head><title>Preview</title></head><body style='margin:0; text-align: center;'><style>body{margin:0;} .previewLoading { display:none; } </style><iframe width='100%'  height='1000' style='border:0;' src=" +
                PDFDocument +
                "></iframe></body></html>"
            );
          this.setState({ isLoading: false });
        } else {
          console.log("PDFDocument Error=>", "<p>" + res.data.Reason + "</p>");
          pdfWindow.document
            .open()
            .write(
              "<html><head><title>Preview</title></head><body style='margin:0; text-align: center;'><style>body{margin:0;} .previewLoading { display:none; } </style><h1 style='color:red;'>" +
                res.data.Reason +
                "</h1></body></html>"
            );
          this.setState({ isLoading: false });
        }
      })
      .catch((error) => {
        console.log("PDFDocument Error=>", "<p>" + error + "</p>");
        var pdfWindow = window.open();
        pdfWindow.document
          .open()
          .write(
            "<html><head><title>Preview</title></head><body style='margin:0; text-align: center;'><h1 class='previewLoading'>Loading.....</h1></body></html>"
          );

        pdfWindow.document
          .open()
          .write(
            "<html><head><title>Preview</title></head><body style='margin:0; text-align: center;'><style>body{margin:0;} .previewLoading { display:none; } </style><h1 style='color:red;'>" +
              error +
              "</h1></body></html>"
          );
        this.setState({ isLoading: false });
      });
  };

  // -- -- API Calls -- -- //
  // -- -- -- --  -- -- -- //

  getSpecificFormTemplates(ids) {
    return API.post("formpack", "/formpack/get-multiple-form-templates-all", {
      body: {
        array: ids,
      },
    });
  }

  deleteDraftApi(guid) {
    return this.props.postRequest("/documents/delete-document", { Guid: guid });
  }

  getMultipleDocs(tanantGuid) {
    return this.props.postRequest("/documents/get-document-detail", {
      TanantGuid: tanantGuid,
    });
  }

  render() {
    return (
      <div className="Documents">
        <Header
          pageHeading="Documents"
          isLoading={this.state.isLoading}
          props={this.props}
        />
        <div className="clearfix"></div>
        <div className="col-xs-12 col-sm-9 col-md-10 pull-right p0 top_mrg_digital_forms top_mrg_general_custom">
          <div className="col-sm-12 col-md-12 col-lg-12 general_setting_hd">
            <div className="tab_table" id="digital_form_page">
              <div className="horizontal_list_tab">
                <ul className="nav nav-tabs ">
                  {localStorage.getItem("userType") === "Approver" ? (
                    ""
                  ) : (
                    <li className="active">
                      <a
                        href="#tab_default_document_draft"
                        id="tab_default_document_draft"
                        onClick={(e) => this.headerNav(e)}
                        data-toggle="tab"
                      >
                        Draft{" "}
                        <span className="badge" id="tab_default_document_draft">
                          {this.state.Draft}
                        </span>
                      </a>
                    </li>
                  )}

                  {localStorage.getItem("userType") === "Operator" ? (
                    ""
                  ) : (
                    <li
                      className={
                        localStorage.getItem("userType") === "Approver"
                          ? "active"
                          : ""
                      }
                    >
                      <a
                        href="#tab_default_document_Approve"
                        id="tab_default_document_Approve"
                        data-toggle="tab"
                        onClick={(e) => this.headerNav(e)}
                      >
                        Approve{" "}
                        <span
                          className="badge"
                          id="tab_default_document_Approve"
                        >
                          {this.state.Approve}
                        </span>
                      </a>
                    </li>
                  )}

                  <li>
                    <a
                      href="#tab_default_document_Pending"
                      id="tab_default_document_Pending"
                      data-toggle="tab"
                      onClick={(e) => this.headerNav(e)}
                    >
                      Pending{" "}
                      <span className="badge" id="tab_default_document_Pending">
                        {this.state.Pending}
                      </span>
                    </a>
                  </li>

                  {/* <li> */}
                  {/* <a href="#tab_default_document_2"  data-toggle="tab"> */}
                  {/* Pending <span className="badge ">25</span> */}
                  {/* </a> */}
                  {/* </li> */}
                  <li>
                    <a
                      href="#tab_default_document_Declined"
                      id="tab_default_document_Declined"
                      data-toggle="tab"
                      onClick={(e) => this.headerNav(e)}
                    >
                      Declined{" "}
                      <span
                        className="badge"
                        id="tab_default_document_Declined"
                      >
                        {this.state.Declined}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="#tab_default_document_Approved"
                      id="tab_default_document_Approved"
                      onClick={(e) => this.headerNav(e)}
                      data-toggle="tab"
                    >
                      Approved{" "}
                      <span
                        className="badge"
                        id="tab_default_document_Approved"
                      >
                        {this.state.Approved}
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="#tab_default_document_All"
                      id="tab_default_document_All"
                      data-toggle="tab"
                      onClick={(e) => this.headerNav(e)}
                    >
                      All{" "}
                      <span className="badge" id="tab_default_document_All">
                        {this.state.allForms.length}
                      </span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-sm-12">
              <div className="tabbable-panel df_tabs">
                <div className="tabbable-line">
                  <div className="tab-content ">
                    <div id="default_document_draft">
                      <div className="col-xs-12 col-sm-12 col-md-12">
                        <div className="clear40"></div>
                        <div className="row">
                          <div className="col-sm-5">
                            <form className="form searchInput_form">
                              <div className="form-group">
                                <button
                                  type="submit"
                                  className="search_button"
                                  value=""
                                >
                                  <img
                                    src={magnifying_glass}
                                    width="20"
                                    height="20"
                                  />
                                </button>
                                <input
                                  type="text"
                                  onChange={this.searchDrafts}
                                  className="form-control search_input"
                                  placeholder="Search by first name, last name, position, or description"
                                />
                                {/* <a id="documentUrl" href={(this.state.documentUrl !== '') ? this.state.documentUrl : null } onClick={this.checkWorking} target="_blank">Hello</a> */}
                              </div>
                            </form>
                          </div>
                          <div
                            className="col-sm-3 pull-right position_relative"
                            id="btn_plus_digital"
                          >
                            <div className="inline_list_icons">
                              <div style={{ display: "none" }}>
                                <a
                                  href={null}
                                  onClick={(e) => this.sendAllSelectedDocs(e)}
                                >
                                  <button
                                    type="button"
                                    className="btn btn-primary pull-right plus_icon_table btn_plus_cusotm"
                                  >
                                    <img src={envelop_icon} />
                                  </button>
                                </a>
                              </div>

                              <a
                                href=""
                                data-toggle="modal"
                                data-target="#myModal_import_data"
                              >
                                <button
                                  type="button"
                                  className="btn btn-primary pull-right plus_icon_table btn_plus_cusotm"
                                  data-toggle="modal"
                                  data-target="#myModal"
                                >
                                  <img src={upload_icon} />
                                </button>
                              </a>
                              <Link to="/dashboard/insert-document">
                                <button
                                  type="button"
                                  className="btn btn-primary pull-right plus_icon_table btn_plus_cusotm"
                                  data-toggle="modal"
                                  data-target="#myModal"
                                >
                                  <img src={plus_icon} />
                                </button>
                              </Link>
                            </div>
                          </div>
                        </div>
                        <div className="clear10"></div>
                        <div className="overflow_scroll_sm ">
                          <table
                            className="table table-bordered custome_field_table draft_Table"
                            id="digital_form_toggle"
                            width="22%"
                          >
                            <thead>
                              <tr>
                                <th width="5%" align="center">
                                  <div className="tbl_checkbox">
                                    <input
                                      type="checkbox"
                                      name="checkbox3_tbl"
                                      id="checkbox3_tbl"
                                      onChange={(e) => this.handleCheckbox(e)}
                                      checked={this.state.checkbox3_tbl}
                                    />
                                    <label htmlFor="checkbox3_tbl"></label>
                                  </div>
                                </th>
                                <th width="10%" align="center">
                                  Detail
                                </th>
                                <th width="15%" align="center">
                                  First Name
                                </th>
                                <th width="15%" align="center">
                                  Last Name
                                </th>
                                <th width="16%" align="center">
                                  Project
                                </th>
                                <th width="5%">Operator</th>
                                <th
                                  width="14%"
                                  align="center"
                                  className="text-center"
                                >
                                  <center>Approval Group</center>
                                </th>
                                <th width="12%" align="center">
                                  Created
                                </th>
                                {/* <th width="10%" align="center">Email Sent</th> */}
                                {/* <th width="8%" align="center"> Status</th> */}
                                <th width="8%" align="center">
                                  &nbsp;{" "}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.draftForms.length > 0
                                ? this.state.draftForms.map((val, key) => {
                                    return (
                                      <React.Fragment>
                                        <tr>
                                          <td align="center">
                                            <div className="tbl_checkbox">
                                              <input
                                                type="checkbox"
                                                className="form-control checkbox3_tbl"
                                                value={val.guid}
                                                id={"checkbox" + val.guid}
                                              />
                                              <label
                                                for={"checkbox" + val.guid}
                                              ></label>
                                            </div>
                                          </td>
                                          <td align="center">
                                            <a
                                              href={null}
                                              id={val.guid}
                                              onClick={() =>
                                                this.showMore(val.Guid, key)
                                              }
                                            >
                                              <img
                                                id={val.guid + "arrowHandling"}
                                                src={down_arrow_amprvoe}
                                                className="arrowHandling cursorPointer "
                                                alt=""
                                              />
                                            </a>
                                          </td>
                                          <td align="center">
                                            {val.FirstName}
                                          </td>
                                          <td align="center">{val.LastName}</td>
                                          <td align="center">
                                            {val.ProjectName
                                              ? val.ProjectName
                                              : "..."}
                                          </td>
                                          <td align="center">{val.UserName}</td>
                                          <td align="center">
                                            <center>{val.ApprovalGroup}</center>
                                          </td>
                                          <td align="center">
                                            {moment(val.Timestamp).format(
                                              "DD/MM/YY"
                                            )}
                                          </td>

                                          {/* <td align="center">{ (!val.EmailDate ||val.EmailDate==='null')? 'Not Sent': moment(val.EmailDate).format('DD/MM/YY')}</td> */}

                                          {/* <td align="center"><span className="pending_lbl">Pending</span></td> */}
                                          <td align="center">
                                            {val.EmpGuid ===
                                            localStorage.getItem("Guid") ? (
                                              <div className="dropdown">
                                                <img
                                                  className="dropdown-toggle btn_user_down_icon"
                                                  type="button"
                                                  data-toggle="dropdown"
                                                  aria-expanded="false"
                                                  src={more_dots}
                                                />
                                                <ul className="dropdown-menu dropleft dropdown_menu_users_down dropdown_menu_user3">
                                                  <li>
                                                    <a
                                                      href={() => false}
                                                      onClick={this.edit_document.bind(
                                                        this,
                                                        val.Guid
                                                      )}
                                                    >
                                                      <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 20 20"
                                                      >
                                                        <path
                                                          id="ic_create_24px"
                                                          className="cls-1"
                                                          d="M3,18.831V23H7.166L19.453,10.71,15.287,6.544ZM22.675,7.489a1.106,1.106,0,0,0,0-1.566l-2.6-2.6a1.106,1.106,0,0,0-1.566,0L16.476,5.356l4.166,4.166,2.033-2.033Z"
                                                          transform="translate(-3 -2.998)"
                                                        ></path>
                                                      </svg>
                                                      Edit
                                                    </a>
                                                  </li>
                                                  <li>
                                                    <a
                                                      href={() => false}
                                                      onClick={(event) =>
                                                        this.sendDocument(
                                                          val.Guid
                                                        )
                                                      }
                                                    >
                                                      <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 20 16"
                                                      >
                                                        <path
                                                          id="ic_mail_outline_24px"
                                                          className="cls-1"
                                                          d="M20,4H4A2,2,0,0,0,2.01,6L2,18a2.006,2.006,0,0,0,2,2H20a2.006,2.006,0,0,0,2-2V6A2.006,2.006,0,0,0,20,4Zm0,14H4V8l8,5,8-5Zm-8-7L4,6H20Z"
                                                          transform="translate(-2 -4)"
                                                        ></path>
                                                      </svg>
                                                      Send
                                                    </a>
                                                  </li>
                                                  <li>
                                                    <a
                                                      href={() => false}
                                                      className="cursorPointer"
                                                      onClick={(event) =>
                                                        this.deleteDraft(
                                                          val.Guid
                                                        )
                                                      }
                                                    >
                                                      <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="1700 296 15 19.286"
                                                      >
                                                        <path
                                                          id="ic_delete_24px"
                                                          className="cls-1"
                                                          d="M6.071,20.143a2.149,2.149,0,0,0,2.143,2.143h8.571a2.149,2.149,0,0,0,2.143-2.143V7.286H6.071ZM20,4.071H16.25L15.179,3H9.821L8.75,4.071H5V6.214H20Z"
                                                          transform="translate(1695 293)"
                                                        ></path>
                                                      </svg>
                                                      Delete
                                                    </a>
                                                  </li>
                                                </ul>
                                              </div>
                                            ) : (
                                              ""
                                            )}
                                          </td>
                                        </tr>

                                        <tr
                                          id={val.Guid + "aid"}
                                          class="approvel_new_open_table digital_form_table_bdr dpdown docdetail"
                                        >
                                          <td colspan="11">
                                            <table
                                              width="100%"
                                              border="0"
                                              cellspacing="2"
                                              cellpadding="2"
                                            >
                                              <tr>
                                                <td align="left">
                                                  <div class="clear5"></div>
                                                  <table
                                                    width="90%"
                                                    class="tbl_mrg_bottom"
                                                  >
                                                    <thead>
                                                      <tr>
                                                        <th
                                                          width="45%"
                                                          align="left"
                                                        >
                                                          Description
                                                        </th>
                                                        <th
                                                          width="5%"
                                                          align="center"
                                                          class="text-center"
                                                        >
                                                          &nbsp;
                                                        </th>
                                                        <th
                                                          width="5%"
                                                          align="center"
                                                          class="text-center"
                                                        >
                                                          &nbsp;
                                                        </th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      {this.state
                                                        .documentsDescriptionLoading ? (
                                                        <tr>
                                                          <td colspan="3">
                                                            <img
                                                              src={Preloader}
                                                              className="documentDetailLoader"
                                                            />
                                                          </td>
                                                        </tr>
                                                      ) : (
                                                        this.state.selectedDocDetails.map(
                                                          (item, index) => {
                                                            return (
                                                              <tr>
                                                                <td>
                                                                  {item.Desc}
                                                                </td>
                                                                <td colSpan={2}>
                                                                  <img
                                                                    src={
                                                                      file_gray
                                                                    }
                                                                    style={{
                                                                      cursor:
                                                                        "pointer",
                                                                    }}
                                                                    onClick={(
                                                                      event
                                                                    ) =>
                                                                      this.showDocumentPdf(
                                                                        item,
                                                                        index
                                                                      )
                                                                    }
                                                                  />
                                                                </td>
                                                              </tr>
                                                            );
                                                          }
                                                        )
                                                      )}
                                                    </tbody>
                                                  </table>
                                                </td>
                                                <td align="left">
                                                  <table
                                                    width="90%"
                                                    class="tbl_mrg_bottom"
                                                  >
                                                    <thead>
                                                      <tr>
                                                        <th
                                                          width="25%"
                                                          align="left"
                                                        >
                                                          Seq
                                                        </th>
                                                        <th width="45%">
                                                          Approver
                                                        </th>
                                                      </tr>
                                                    </thead>
                                                    {val.ApprovalChain.map(
                                                      (approval) => {
                                                        return (
                                                          <tr>
                                                            <td>
                                                              {
                                                                approval.Sequence
                                                              }
                                                            </td>
                                                            <td>
                                                              {
                                                                approval.ApproverName
                                                              }
                                                            </td>
                                                          </tr>
                                                        );
                                                      }
                                                    )}
                                                  </table>
                                                </td>
                                                <td colspan="3">
                                                  <table
                                                    width="100%"
                                                    class="tbl_mrg_bottom"
                                                  >
                                                    <thead>
                                                      <tr>
                                                        <th
                                                          width="25%"
                                                          align="left"
                                                        >
                                                          Seq
                                                        </th>
                                                        <th width="45%">
                                                          Form Sign By
                                                        </th>
                                                      </tr>
                                                    </thead>
                                                    {val.ExtSigners.map(
                                                      (signer) => {
                                                        return (
                                                          <tr>
                                                            <td>
                                                              {signer.Sequence}
                                                            </td>
                                                            <td>
                                                              {signer.FirstName +
                                                                " " +
                                                                signer.Lastname}
                                                            </td>
                                                          </tr>
                                                        );
                                                      }
                                                    )}
                                                  </table>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td colspan="3">
                                                  <div
                                                    class="panel panel-default help_panel_group"
                                                    id="toggle_data_table"
                                                  >
                                                    <div class="panel-heading hide_activity_heading">
                                                      <h4 class="panel-title">
                                                        <a
                                                          class="accordion-toggle collapsed text_change"
                                                          data-toggle="collapse"
                                                          data-parent="#accordion"
                                                          href={
                                                            "#show_activity" +
                                                            key
                                                          }
                                                        >
                                                          Show Activity
                                                        </a>
                                                      </h4>
                                                    </div>
                                                    <div
                                                      id={"show_activity" + key}
                                                      class="panel-collapse collapse"
                                                    >
                                                      <div class="panel-body hide_show_panel">
                                                        {val.Activity.slice(
                                                          0,
                                                          5
                                                        ).map((item) => {
                                                          return (
                                                            <p>
                                                              <span>
                                                                {item.User}
                                                              </span>
                                                              {item.Description}
                                                            </p>
                                                          );
                                                        })}
                                                        <p class="last_child_border">
                                                          {" "}
                                                          <a
                                                            href=""
                                                            data-toggle="modal"
                                                            onClick={this.selectedDocumentToshowActivities.bind(
                                                              this,
                                                              key
                                                            )}
                                                            data-target="#myModal_activity"
                                                          >
                                                            read more
                                                          </a>
                                                        </p>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>
                                            </table>
                                          </td>
                                        </tr>
                                      </React.Fragment>
                                    );
                                  })
                                : ""}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                    <div
                      className="tab-pane active"
                      id="default_document_Approve"
                    >
                      <div className="clear30"></div>
                      <div id="approve_box">
                        <div className="col-sm-3 sidebar_main document_sidebar_scroll">
                          <div className="clear40"></div>
                          <div className="grid_layout">
                            <div className="grid_layout_inner">
                              <select
                                name="sortBy"
                                value={this.state.sortBy}
                                onChange={(event) => this.sortBy(event)}
                                className="form_detail_select"
                              >
                                <option value="">Sort By</option>
                                <option value="Asc">Asc</option>
                                <option value="Desc">Desc</option>
                              </select>
                            </div>
                            <div className="grid_layout_inner">
                              <form className="form searchInput_form">
                                <div className="form-group">
                                  <button
                                    type="button"
                                    className="search_button"
                                    value=""
                                  >
                                    <img
                                      src={magnifying_glass}
                                      width="20"
                                      height="20"
                                      alt=""
                                    />
                                  </button>
                                  <input
                                    type="text"
                                    name="search"
                                    onChange={this.search}
                                    value={this.state.search}
                                    className="form-control search_input"
                                    onChange={(event) => this.search(event)}
                                    placeholder="What are you looking for"
                                  />
                                </div>
                              </form>
                            </div>
                          </div>
                          <div className="clear20"></div>
                          {this.state.approverForms.length > 0
                            ? this.state.approverForms.map((result, key) => {
                                return (
                                  <div
                                    className={
                                      "grid_layout_content " +
                                      (result.Guid ===
                                      this.state.CurrentForm?.Guid
                                        ? "active"
                                        : "cursorPointer")
                                    }
                                    key={key}
                                    onClick={(event) =>
                                      this.updateCurrentForm(result.Guid)
                                    }
                                  >
                                    <div className="grid_content">
                                      <h3>
                                        {result.FirstName +
                                          " " +
                                          result.LastName}
                                      </h3>
                                      {result.CustomFields.map(function (
                                        department,
                                        key
                                      ) {
                                        return <p>{department.Name}</p>;
                                      })}
                                      <p>
                                        Date:{" "}
                                        {moment
                                          .unix(result.CreatedTS)
                                          .format("DD/MM/YYYY")}{" "}
                                      </p>
                                    </div>

                                    <div className="grid_content">
                                      <h3>Next Approver:</h3>
                                      <p>
                                        {result.ApprovalChain.find(
                                          (approver) =>
                                            parseInt(approver.Signed) === 0
                                        )?.ApproverName ?? "N/A"}{" "}
                                      </p>
                                      <p>&nbsp; &nbsp; &nbsp;</p>
                                      <a
                                        href=""
                                        id={result.Guid}
                                        data-toggle="modal"
                                        data-target="#myModal_more_detail"
                                        onClick={(event) =>
                                          this.moreDetailsModalOpen(event)
                                        }
                                      >
                                        More Details
                                      </a>
                                    </div>
                                  </div>
                                );
                              })
                            : ""}
                        </div>
                        <div className="col-sm-1 p0 toggle_button_div slide-toggle cursorPointer">
                          <a href={null}>
                            <i className="fas fa-caret-left"></i>
                          </a>
                        </div>
                        <div className="col-sm-8 sidebar_main_right">
                          {this.state.CurrentTab === "Approve" &&
                          this.state.CurrentForm
                            ? this.renderCurrentForm()
                            : ""}
                        </div>
                      </div>
                    </div>
                    <div
                      className="tab-pane active"
                      id="default_document_Pending"
                    >
                      <div className="clear30"></div>
                      <div id="approve_box">
                        <div className="col-sm-3 sidebar_main document_sidebar_scroll">
                          <div className="clear40"></div>
                          <div className="grid_layout">
                            <div className="grid_layout_inner">
                              <select
                                name="sortBy"
                                value={this.state.sortBy}
                                onChange={(event) => this.sortBy(event)}
                                className="form_detail_select"
                              >
                                <option value="">Sort By</option>
                                <option value="Asc">Asc</option>
                                <option value="Desc">Desc</option>
                              </select>
                            </div>
                            <div className="grid_layout_inner">
                              <form className="form searchInput_form">
                                <div className="form-group">
                                  <button
                                    type="button"
                                    className="search_button"
                                    value=""
                                  >
                                    <img
                                      src={magnifying_glass}
                                      width="20"
                                      height="20"
                                      alt=""
                                    />
                                  </button>
                                  <input
                                    type="text"
                                    name="search"
                                    onChange={this.search}
                                    value={this.state.search}
                                    className="form-control search_input"
                                    onChange={(event) => this.search(event)}
                                    placeholder="What are you looking for"
                                  />
                                </div>
                              </form>
                            </div>
                          </div>
                          <div className="clear20"></div>
                          {this.state.pendingForms.length > 0
                            ? this.state.pendingForms.map((result, key) => {
                                return (
                                  <div
                                    className={
                                      "grid_layout_content " +
                                      (result.Guid ===
                                      this.state.CurrentForm?.Guid
                                        ? "active"
                                        : "cursorPointer")
                                    }
                                    key={key}
                                    onClick={(event) =>
                                      this.updateCurrentForm(result.Guid)
                                    }
                                  >
                                    <div className="grid_content">
                                      <h3>
                                        {result.FirstName +
                                          " " +
                                          result.LastName}
                                      </h3>
                                      {result.CustomFields.map(function (
                                        department,
                                        key
                                      ) {
                                        return <p>{department.Name}</p>;
                                      })}
                                      <p>
                                        Date:{" "}
                                        {moment
                                          .unix(result.CreatedTS)
                                          .format("DD/MM/YYYY")}{" "}
                                      </p>
                                    </div>

                                    <div className="grid_content">
                                      <h3>Next Approver:</h3>
                                      <p>
                                        {result.ApprovalChain.find(
                                          (approver) =>
                                            parseInt(approver.Signed) === 0
                                        )?.ApproverName ?? "N/A"}{" "}
                                      </p>
                                      <p>&nbsp; &nbsp; &nbsp;</p>
                                      <a
                                        href=""
                                        id={result.Guid}
                                        data-toggle="modal"
                                        data-target="#myModal_more_detail"
                                        onClick={(event) =>
                                          this.moreDetailsModalOpen(event)
                                        }
                                      >
                                        More Details
                                      </a>
                                    </div>
                                  </div>
                                );
                              })
                            : ""}
                        </div>
                        <div className="col-sm-1 p0 toggle_button_div slide-toggle cursorPointer">
                          <a href={null}>
                            <i className="fas fa-caret-left"></i>
                          </a>
                        </div>
                        <div className="col-sm-8 sidebar_main_right">
                          {this.state.CurrentTab === "Pending" &&
                          this.state.CurrentForm
                            ? this.renderCurrentForm()
                            : ""}
                        </div>
                      </div>
                    </div>

                    <div
                      className="tab-pane active"
                      id="default_document_Approved"
                    >
                      <div className="clear30"></div>
                      <div id="approve_box">
                        <div className="col-sm-3 sidebar_main document_sidebar_scroll">
                          <div className="clear40"></div>
                          <div className="grid_layout">
                            <div className="grid_layout_inner">
                              <select
                                name="sortBy"
                                value={this.state.sortBy}
                                onChange={(event) => this.sortBy(event)}
                                className="form_detail_select"
                              >
                                <option value="">Sort By</option>
                                <option value="Asc">Asc</option>
                                <option value="Desc">Desc</option>
                              </select>
                            </div>
                            <div className="grid_layout_inner">
                              <form className="form searchInput_form">
                                <div className="form-group">
                                  <button
                                    type="button"
                                    className="search_button"
                                    value=""
                                  >
                                    <img
                                      src={magnifying_glass}
                                      width="20"
                                      height="20"
                                      alt=""
                                    />
                                  </button>
                                  <input
                                    type="text"
                                    name="search"
                                    onChange={this.search}
                                    value={this.state.search}
                                    className="form-control search_input"
                                    onChange={(event) => this.search(event)}
                                    placeholder="What are you looking for"
                                  />
                                </div>
                              </form>
                            </div>
                          </div>
                          <div className="clear20"></div>
                          {this.state.approvedForms.length > 0
                            ? this.state.approvedForms.map((result, key) => {
                                return (
                                  <div
                                    className={
                                      "grid_layout_content " +
                                      (result.Guid ===
                                      this.state.CurrentForm?.Guid
                                        ? "active"
                                        : "cursorPointer")
                                    }
                                    key={key}
                                    onClick={(event) =>
                                      this.updateCurrentForm(result.Guid)
                                    }
                                  >
                                    <div className="grid_content">
                                      <h3>
                                        {result.FirstName +
                                          " " +
                                          result.LastName}
                                      </h3>
                                      {result.CustomFields.map(function (
                                        department,
                                        key
                                      ) {
                                        return <p>{department.Name}</p>;
                                      })}
                                      <p>
                                        Date:{" "}
                                        {moment
                                          .unix(result.CreatedTS)
                                          .format("DD/MM/YYYY")}{" "}
                                      </p>
                                    </div>

                                    <div className="grid_content">
                                      <h3>Next Approver:</h3>
                                      <p>
                                        {result.ApprovalChain.find(
                                          (approver) =>
                                            parseInt(approver.Signed) === 0
                                        )?.ApproverName ?? "N/A"}{" "}
                                      </p>
                                      <p>&nbsp; &nbsp; &nbsp;</p>
                                      <a
                                        href=""
                                        id={result.Guid}
                                        data-toggle="modal"
                                        data-target="#myModal_more_detail"
                                        onClick={(event) =>
                                          this.moreDetailsModalOpen(event)
                                        }
                                      >
                                        More Details
                                      </a>
                                    </div>
                                  </div>
                                );
                              })
                            : ""}
                        </div>
                        <div className="col-sm-1 p0 toggle_button_div slide-toggle cursorPointer">
                          <a href={null}>
                            <i className="fas fa-caret-left"></i>
                          </a>
                        </div>
                        <div className="col-sm-8 sidebar_main_right">
                          {this.state.CurrentTab === "Approved" &&
                          this.state.CurrentForm
                            ? this.renderCurrentForm()
                            : ""}
                        </div>
                      </div>
                    </div>

                    <div
                      className="tab-pane active"
                      id="default_document_Declined"
                    >
                      <div className="clear30"></div>
                      <div id="approve_box">
                        <div className="col-sm-3 sidebar_main document_sidebar_scroll">
                          <div className="clear40"></div>
                          <div className="grid_layout">
                            <div className="grid_layout_inner">
                              <select
                                name="sortBy"
                                value={this.state.sortBy}
                                onChange={(event) => this.sortBy(event)}
                                className="form_detail_select"
                              >
                                <option value="">Sort By</option>
                                <option value="Asc">Asc</option>
                                <option value="Desc">Desc</option>
                              </select>
                            </div>
                            <div className="grid_layout_inner">
                              <form className="form searchInput_form">
                                <div className="form-group">
                                  <button
                                    type="button"
                                    className="search_button"
                                    value=""
                                  >
                                    <img
                                      src={magnifying_glass}
                                      width="20"
                                      height="20"
                                      alt=""
                                    />
                                  </button>
                                  <input
                                    type="text"
                                    name="search"
                                    onChange={this.search}
                                    value={this.state.search}
                                    className="form-control search_input"
                                    onChange={(event) => this.search(event)}
                                    placeholder="What are you looking for"
                                  />
                                </div>
                              </form>
                            </div>
                          </div>
                          <div className="clear20"></div>
                          {this.state.declinedForms.length > 0
                            ? this.state.declinedForms.map((result, key) => {
                                return (
                                  <div
                                    className={
                                      "grid_layout_content " +
                                      (result.Guid ===
                                      this.state.CurrentForm?.Guid
                                        ? "active"
                                        : "cursorPointer")
                                    }
                                    key={key}
                                    onClick={(event) =>
                                      this.updateCurrentForm(result.Guid)
                                    }
                                  >
                                    <div className="grid_content">
                                      <h3>
                                        {result.FirstName +
                                          " " +
                                          result.LastName}
                                      </h3>
                                      {result.CustomFields.map(function (
                                        department,
                                        key
                                      ) {
                                        return <p>{department.Name}</p>;
                                      })}
                                      <p>
                                        Date:{" "}
                                        {moment
                                          .unix(result.CreatedTS)
                                          .format("DD/MM/YYYY")}{" "}
                                      </p>
                                    </div>

                                    <div className="grid_content">
                                      <h3>Next Approver:</h3>
                                      <p>
                                        {result.ApprovalChain.find(
                                          (approver) =>
                                            parseInt(approver.Signed) === 0
                                        )?.ApproverName ?? "N/A"}{" "}
                                      </p>

                                      <p>&nbsp; &nbsp; &nbsp;</p>
                                      <a
                                        href=""
                                        id={result.Guid}
                                        data-toggle="modal"
                                        data-target="#myModal_more_detail"
                                        onClick={(event) =>
                                          this.moreDetailsModalOpen(event)
                                        }
                                      >
                                        More Details
                                      </a>
                                    </div>
                                  </div>
                                );
                              })
                            : ""}
                        </div>
                        <div className="col-sm-1 p0 toggle_button_div slide-toggle cursorPointer">
                          <a href={null}>
                            <i className="fas fa-caret-left"></i>
                          </a>
                        </div>
                        <div className="col-sm-8 sidebar_main_right">
                          {this.state.CurrentTab === "Declined" &&
                          this.state.CurrentForm
                            ? this.renderCurrentForm()
                            : ""}
                        </div>
                      </div>
                    </div>

                    <div className="tab-pane active" id="default_document_All">
                      <div className="clear30"></div>
                      <div id="approve_box">
                        <div className="col-sm-3 sidebar_main document_sidebar_scroll">
                          <div className="clear40"></div>
                          <div className="grid_layout">
                            <div className="grid_layout_inner">
                              <select
                                name="sortBy"
                                value={this.state.sortBy}
                                onChange={(event) => this.sortBy(event)}
                                className="form_detail_select"
                              >
                                <option value="">Sort By</option>
                                <option value="Asc">Asc</option>
                                <option value="Desc">Desc</option>
                              </select>
                            </div>
                            <div className="grid_layout_inner">
                              <form className="form searchInput_form">
                                <div className="form-group">
                                  <button
                                    type="button"
                                    className="search_button"
                                    value=""
                                  >
                                    <img
                                      src={magnifying_glass}
                                      width="20"
                                      height="20"
                                      alt=""
                                    />
                                  </button>
                                  <input
                                    type="text"
                                    name="search"
                                    onChange={this.search}
                                    value={this.state.search}
                                    className="form-control search_input"
                                    onChange={(event) => this.search(event)}
                                    placeholder="What are you looking for"
                                  />
                                </div>
                              </form>
                            </div>
                          </div>
                          <div className="clear20"></div>
                          {this.state.allForms.length > 0
                            ? this.state.allForms.map((result, key) => {
                                var currentApproverIndex =
                                  this.findNextApprover(result.ApprovalChain);
                                return (
                                  <div
                                    className={
                                      "grid_layout_content " +
                                      (result.Guid ===
                                      this.state.CurrentForm?.Guid
                                        ? "active"
                                        : "cursorPointer")
                                    }
                                    key={key}
                                    onClick={(event) =>
                                      this.updateCurrentForm(result.Guid)
                                    }
                                  >
                                    <div className="grid_content">
                                      <h3>
                                        {result.FirstName +
                                          " " +
                                          result.LastName}
                                      </h3>
                                      {result.CustomFields.map(function (
                                        department,
                                        key
                                      ) {
                                        return <p>{department.Name}</p>;
                                      })}
                                      <p>
                                        Date:{" "}
                                        {moment
                                          .unix(result.CreatedTS)
                                          .format("DD/MM/YYYY")}{" "}
                                      </p>
                                    </div>

                                    <div className="grid_content">
                                      <h3>Next Approver:</h3>
                                      <p>
                                        {result.ApprovalChain.find(
                                          (approver) =>
                                            parseInt(approver.Signed) === 0
                                        )?.ApproverName ?? "N/A"}{" "}
                                      </p>
                                      <p>&nbsp; &nbsp; &nbsp;</p>
                                      <a
                                        href=""
                                        id={result.Guid}
                                        data-toggle="modal"
                                        data-target="#myModal_more_detail"
                                        onClick={(event) =>
                                          this.moreDetailsModalOpen(event)
                                        }
                                      >
                                        More Details
                                      </a>
                                    </div>
                                  </div>
                                );
                              })
                            : ""}
                        </div>
                        <div className="col-sm-1 p0 toggle_button_div slide-toggle cursorPointer">
                          <a href={null}>
                            <i className="fas fa-caret-left"></i>
                          </a>
                        </div>
                        <div className="col-sm-8 sidebar_main_right">
                          {this.state.CurrentTab === "All" &&
                          this.state.CurrentForm
                            ? this.renderCurrentForm()
                            : ""}
                        </div>
                      </div>
                    </div>

                    <div className="tab-pane" id="tab_default_3">
                      tab 3
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="clear10"></div>
        </div>
        <div className="clear10"></div>
        <div id="myModal_activity" className="modal fade" role="dialog">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className="close DocumentOutlineNone"
                  data-dismiss="modal"
                >
                  <img
                    src={ic_clear_24px}
                    className="mt22"
                    width="18"
                    height="18"
                    alt=""
                  />
                </button>
                <h4 className="modal-title modal_customefield activity_pop1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 13.334"
                  >
                    <path
                      id="ic_sort_24px"
                      className="cls-1"
                      d="M3,19.333H9.667V17.111H3ZM3,6V8.222H23V6Zm0,7.778H16.333V11.556H3Z"
                      transform="translate(-3 -6)"
                    />
                  </svg>
                  Activity
                </h4>
              </div>
              <div className="modal-body label_modal_custom">
                <div className="clear20"></div>
                {this.state.selectedDocumentForReadAllActivities === ""
                  ? ""
                  : this.state.selectedDocumentForReadAllActivities.Activity.map(
                      (item) => {
                        return (
                          <div className="col-sm-12 active_pop_label">
                            <strong>{item.User}</strong> {item.Description}
                          </div>
                        );
                      }
                    )}

                <div className="clear20"></div>
              </div>
            </div>
          </div>
        </div>
        <div id="myModal_attachments" className="modal fade" role="dialog">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className="close DocumentOutlineNone"
                  data-dismiss="modal"
                >
                  <img
                    src={ic_clear_24px}
                    className="mt22"
                    width="18"
                    height="18"
                    alt=""
                  />
                </button>
                <h4 className="modal-title modal_customefield activity_pop1 attach_imgsvg">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120">
                    <path
                      id="ic_library_books_24px"
                      className="cls-1"
                      d="M14,26H2v84a12.035,12.035,0,0,0,12,12H98V110H14ZM110,2H38A12.035,12.035,0,0,0,26,14V86A12.035,12.035,0,0,0,38,98h72a12.035,12.035,0,0,0,12-12V14A12.035,12.035,0,0,0,110,2Zm-6,54H44V44h60ZM80,80H44V68H80Zm24-48H44V20h60Z"
                      transform="translate(-2 -2)"
                    />
                  </svg>
                  Attachments
                </h4>
              </div>
              <div className="modal-body label_modal_custom modal_digi_form_attach">
                <div className="clear20"></div>
                <table width="100%" border="0" cellSpacing="2" cellPadding="2">
                  <thead>
                    <tr>
                      <th colSpan="2" align="left" valign="middle">
                        Description
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.selectedAttachments.length < 1 ? (
                      <tr>
                        <td width="95%" align="left" valign="middle">
                          No attachments available
                        </td>
                      </tr>
                    ) : (
                      this.state.selectedAttachments.map((item) => {
                        return (
                          <tr>
                            <td width="95%" align="left" valign="middle">
                              {item.filename}
                            </td>
                            <td width="5%" align="center">
                              <img
                                src={file_gray}
                                alt=""
                                style={{ cursor: "pointer" }}
                                onClick={this.onShowDocument.bind(
                                  this,
                                  item.url
                                )}
                              />
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
                <div className="clear40"></div>
              </div>
            </div>
          </div>
        </div>
        <div id="myModal_import_data" className="modal fade" role="dialog">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className="close DocumentOutlineNone"
                  data-dismiss="modal"
                >
                  <img
                    src={ic_clear_24px}
                    className="mt22"
                    width="18"
                    height="18"
                    alt=""
                  />
                </button>
                <h4 className="modal-title modal_customefield">
                  Import Excel Data
                </h4>
              </div>
              <div className="modal-body label_modal_custom modal_digi_form_attach">
                <div className="clear30"></div>
                <div className="col-sm-12">
                  <textarea
                    name="excelImportData"
                    value={this.state.excelImportData}
                    className="textarea_imprt_data"
                    onChange={this.onChangeHandler}
                    cols=""
                    rows=""
                    placeholder="Paste Excel Data Here"
                  ></textarea>
                </div>
                <div className="clear20"></div>
                <div className="col-sm-12">
                  <div className="btn_cance_save">
                    <button
                      type="button"
                      className="btn_save_pro"
                      onClick={this.onPaste}
                      data-dismiss="modal"
                    >
                      Save
                    </button>
                    <button
                      type="button"
                      className="btn_cancel_pro"
                      data-dismiss="modal"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
                <div className="clear30"></div>
              </div>
            </div>
          </div>
        </div>

        <div id="myModal_aprove_tabattach" className="modal fade" role="dialog">
          <div className="modal-dialog">
            <div className="modal-content">
              {this.state.isLoading === true ? (
                <div className="se-pre-con"></div>
              ) : (
                ""
              )}
              <div className="modal-header">
                <button
                  type="button"
                  className="close DocumentOutlineNone"
                  data-dismiss="modal"
                >
                  <img
                    src={ic_clear_24px}
                    className="mt22"
                    width="18"
                    height="18"
                    alt=""
                  />
                </button>
                <h4 className="modal-title modal_customefield">Attachments</h4>
              </div>
              <div className="modal-body label_modal_custom attchment_bottom_h">
                <div className="clear10"></div>
                <div className="col-sm-12 attchment_bottom_label">
                  <table
                    width="100%"
                    border="0"
                    cellSpacing="2"
                    cellPadding="2"
                    className="digi_attach_pop_area4"
                  >
                    <thead>
                      <tr>
                        <th width="95%" align="left">
                          Form Attachment Description
                        </th>
                        <th width="5%" align="left"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.docAttachments?.length > 0 ? (
                        this.state.docAttachments.map((val, key) => {
                          return (
                            <tr key={key} className="custom_field_tab">
                              <td>{val.filename}</td>
                              <td>
                                <a
                                  href={null}
                                  style={{ cursor: "pointer" }}
                                  onClick={
                                    () => this.previewAttachment(val.url)
                                    // this.OpenFile(Docs.url)
                                  }
                                >
                                  <img
                                    src={file_gray}
                                    width="16"
                                    height="24"
                                    alt=""
                                  />
                                </a>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr className="custom_field_tab">
                          <td>No Attachments</td>
                          <td>&nbsp;</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <div className="clear30"></div>

                  <table
                    width="100%"
                    border="0"
                    cellSpacing="2"
                    cellPadding="2"
                    className="digi_attach_pop_area4"
                  >
                    <thead>
                      <tr>
                        <th width="95%" align="left">
                          External Attachment Description
                        </th>
                        <th width="5%" align="left"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.doc_external_list?.length > 0 ? (
                        this.state.doc_external_list.map((val, key) => {
                          return (
                            <tr key={key} className="custom_field_tab">
                              <td>{val.split("formTemplate-documents/")}</td>
                              <td>
                                <a
                                  href={null}
                                  style={{ cursor: "pointer" }}
                                  onClick={
                                    () => this.previewAttachment(val)
                                    // this.OpenFile(Docs.url)
                                  }
                                >
                                  <img
                                    src={file_gray}
                                    width="16"
                                    height="24"
                                    alt=""
                                  />
                                </a>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr className="custom_field_tab">
                          <td>No Attachments</td>
                          <td>&nbsp;</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="clear10"></div>
                <div className="col-sm-12">
                  <div className="btn_cance_save">
                    <button
                      type="button"
                      className="btn_cancel_pro"
                      data-dismiss="modal"
                    >
                      Close
                    </button>
                  </div>
                </div>
                <div className="clear20"></div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          id="myModal_more_detail"
          show={this.state.moreDetailsModalOpen}
          onHide={(event) => this.moreDetailsModalClose(event)}
          className="modal modal2 fade"
          role="dialog"
        >
          <div className="modal-header">
            <button
              type="button"
              className="close DocumentOutlineNone"
              onClick={(event) => this.moreDetailsModalClose(event)}
            >
              <img
                src={ic_clear_24px}
                className="mt22"
                width="18"
                height="18"
                alt=""
              />
            </button>
          </div>
          <div className="modal-body label_modal_custom attchment_bottom_h">
            <div className="clear10"></div>
            <div className="col-sm-12 attchment_bottom_label">
              <table
                width="100%"
                border="0"
                cellSpacing="2"
                cellPadding="2"
                className="digi_kevin_plum_poptable"
              >
                <thead>
                  <tr>
                    <td width="30%" align="left" valign="middle">
                      Created:
                    </td>
                    <td width="70%" align="left" valign="middle">
                      {moment(this.state.digitalForm.Timestamp).format(
                        "DD/MM/YY"
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td align="left" valign="middle">
                      Status:
                    </td>
                    <td align="left" valign="middle">
                      {" "}
                      {this.state.digitalForm.Status}
                    </td>
                  </tr>
                  {this.state.digitalForm.Status === "Declined" &&
                    this.state.digitalForm.DeclinedReason && (
                      <tr>
                        <td align="left" valign="middle">
                          Declined Reason:
                        </td>
                        <td align="left" valign="middle">
                          {" "}
                          {this.state.digitalForm.DeclinedReason}
                        </td>
                      </tr>
                    )}
                  <tr>
                    <td align="left" valign="middle">
                      Operator:
                    </td>
                    <td align="left" valign="middle">
                      {this.state.digitalForm.UserName}
                    </td>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
              <div className="clear20"></div>
              <div className="row">
                <div className="col-sm-6">
                  <table
                    width="100%"
                    border="0"
                    cellSpacing="2"
                    cellPadding="2"
                    className="digi_kevin_plum_poptable5 table-approver-document"
                  >
                    <thead>
                      <tr>
                        <th width="12%" align="left">
                          Seq
                        </th>
                        <th width="70%" align="left">
                          Approver
                        </th>
                        <th width="18%" align="left"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.isDigitalFormExist
                        ? this.renderApprovalChain()
                        : "record not found"}
                    </tbody>
                  </table>
                </div>
                <div className="col-sm-6">
                  <table
                    width="100%"
                    border="0"
                    cellSpacing="2"
                    cellPadding="2"
                    className="digi_kevin_plum_poptable5 table-approver-document"
                  >
                    <thead>
                      <tr>
                        <th width="12%" align="left">
                          Seq
                        </th>
                        <th width="70%" align="left">
                          Form Sign By
                        </th>
                        <th width="18%" align="left"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.isDigitalFormExist
                        ? this.renderExternalSigner()
                        : "record not found"}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="clear20"></div>
          </div>
        </Modal>
        <div
          id="myModal_comment_digi_form"
          className="modal fade"
          role="dialog"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className="close DocumentOutlineNone"
                  data-dismiss="modal"
                >
                  <img
                    src={ic_clear_24px}
                    className="mt22"
                    width="18"
                    height="18"
                    alt=""
                  />
                </button>
                <h4 className="modal-title modal_customefield">Comment</h4>
              </div>
              <div className="modal-body label_modal_custom modal_pop_digi_comment8">
                <div className="clear20"></div>
                <div className="col-sm-12">
                  <div className="comment_box_pop_digi6">
                    {this.state.CurrentForm === false
                      ? "test"
                      : this.state.CurrentForm?.Comments.length > 0
                      ? this.state.CurrentForm?.Comments.map((value) => {
                          return (
                            <div className="comment_box_labelarea6">
                              <div className="col-sm-12 text-left label1">
                                {value.Name}
                              </div>
                              <div className="col-sm-12 text-right label2">
                                {value.DateTime}
                              </div>
                              <div className="col-sm-12 text-left label3">
                                {value.Comment}
                              </div>
                              <div className="clearfix"></div>
                            </div>
                          );
                        })
                      : "No Comments Found"}
                  </div>
                  <div className="clear40"></div>
                  <div>Add a Comment</div>
                  <div className="clear10"></div>
                  <div className="col-sm-12 p0">
                    <textarea
                      name="comment_add"
                      value={this.state.comment_add}
                      className="textarea_comment_add_pop7"
                      cols=""
                      rows=""
                      onChange={(event) => this.handleChangeText(event)}
                    ></textarea>
                  </div>
                </div>
                <div className="clear20"></div>
                <div className="col-sm-12">
                  <div className="btn_cance_save">
                    <button
                      type="button"
                      className="btn_add_comment9"
                      onClick={this.addComment}
                    >
                      Add Comment
                    </button>
                    <button
                      type="button"
                      id="Close_comment"
                      className="btn_add_comment9 displayNo"
                      data-dismiss="modal"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
                <div className="clear30"></div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          id="myModal_decline_digi_form"
          show={this.state.declineModalOpen}
          onHide={(event) => this.declineModalClose(event)}
          className="modal modal2 fade"
          role="dialog"
        >
          <div className="modal-header p0 bdr_none_9">
            <button
              type="button"
              className="close DocumentOutlineNone"
              onClick={(event) => this.declineModalClose()}
            >
              <img
                src={decline_pop_close}
                className="decline_pop_close mt22"
                alt=""
              />
            </button>
            <h4 className="modal-title modal_decline_hdr ">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <path
                  id="ic_not_interested_24px"
                  className="cls-1"
                  d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,0,1-8-8A7.9,7.9,0,0,1,5.69,7.1L16.9,18.31A7.9,7.9,0,0,1,12,20Zm6.31-3.1L7.1,5.69A7.9,7.9,0,0,1,12,4a8,8,0,0,1,8,8A7.9,7.9,0,0,1,18.31,16.9Z"
                  transform="translate(-2 -2)"
                />
              </svg>
            </h4>
          </div>
          <div className="modal-body label_modal_custom modal_digi_form_attach">
            <div className="clear30"></div>
            <div className="col-sm-12 p0">
              <div className="col-sm-12 decline_img_pop">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="-10048 7722.143 16 16"
                >
                  <path
                    id="ic_edit_24px"
                    className="cls-1"
                    d="M3,15.665V19H6.333l9.83-9.83L12.83,5.835ZM18.74,6.59a.885.885,0,0,0,0-1.253l-2.08-2.08a.885.885,0,0,0-1.253,0L13.781,4.884l3.333,3.333L18.74,6.59Z"
                    transform="translate(-10051 7719.146)"
                  ></path>
                </svg>
                <textarea
                  name="DeclineText"
                  onChange={(event) => this.handleChangeText(event)}
                  className="form-control decline_textraea_contact"
                  cols=""
                  rows=""
                  placeholder="Message"
                >
                  {this.state.DeclineText}
                </textarea>
              </div>
            </div>
            <div className="clear20"></div>
            <div className="col-sm-12">
              <div className="btn_cance_save">
                <div className="col-sm-6 p0">
                  <button
                    type="button"
                    className="btn_cancel_pro pull-left"
                    onClick={(event) => this.declineModalClose()}
                  >
                    Cancel
                  </button>
                </div>
                <div className="col-sm-6 p0">
                  {" "}
                  <button
                    type="button"
                    className="btn_save_pro pull-right"
                    data-dismiss="modal"
                    onClick={(event) => this.declineForm(event)}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
            <div className="clear30"></div>
          </div>
        </Modal>
        <Modal
          show={this.state.handleSendLinkToUserShow}
          onHide={(event) => this.handleSendLinkToUserClose()}
          className="modal modal2 fade"
          role="dialog"
        >
          <div className="modal-header">
            <button
              type="button"
              className="close customfields_OutlineNone"
              data-dismiss="modal"
              onClick={(event) => this.handleSendLinkToUserClose()}
            >
              <img
                className="customfields_mt20"
                src={ic_clear_24px}
                width="18"
                height="18"
                alt=""
              />
            </button>
            <h4 className="modal-title modal_customefield">
              Send Link To User
            </h4>
          </div>
          <div className="modal-body label_modal_custom">
            <div className="clear10"></div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-sm-3 col-md-2 label_csutom_pop">
                Select User:
              </div>
              <div className="col-sm-9 col-md-6">
                <select
                  name="projectedUsers"
                  onChange={(event) => this.handleProjectedUsersSelect(event)}
                >
                  <option value="">Select User</option>
                  {this.showProjectedUsers()}
                </select>
                <p
                  className={
                    "error validation " +
                    (this.state.selectProjectedUserError ? "" : "displayNone")
                  }
                >
                  {this.state.selectProjectedUserError}
                </p>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10 user_label_email">
              Please enter any CC Emails and Notes to the user below. When you
              press send, an email will be sent to the user containing their
              login details, instructions on how to login, and help
              documentation.
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-sm-3 col-md-2 label_csutom_pop">CC:</div>
              <div className="col-sm-9 col-md-10">
                <input
                  name="CarbonCopyEmail"
                  type="text"
                  onChange={(event) =>
                    this.handleCustomFieldsModalInputs(event)
                  }
                  value={this.state.CarbonCopyEmail}
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-sm-3 col-md-2 label_csutom_pop">Notes:</div>
              <div className="col-sm-9 col-md-10">
                <textarea
                  name="EmailExtraText"
                  onChange={(event) =>
                    this.handleCustomFieldsModalInputs(event)
                  }
                  value={this.state.EmailExtraText}
                  className="text_area_user"
                  cols=""
                  rows=""
                ></textarea>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="btn_cance_save">
                <button
                  type="button"
                  onClick={(event) => this.SendLinkToProjectedUser(event)}
                  className="btn_save_pro"
                  data-dismiss="modal"
                >
                  Save
                </button>
                <button
                  type="button"
                  onClick={(event) => this.handleSendLinkToUserClose()}
                  className="btn_cancel_pro"
                  data-dismiss="modal"
                >
                  Cancel
                </button>
              </div>
            </div>
            <div className="clear20"></div>
          </div>
        </Modal>
      </div>
    );
  }
}
export default Documents;
